// @ts-nocheck: plain untyped ES5, kept out of Horizon's strict checkJs (assets/jsconfig.json).
/* Havehandel storefront behaviour, ported from the prototype's ui.js one feature at a time. */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;


  function loop(el, pps) {
    if (!el || !el.children.length) return;
    var original = Array.prototype.slice.call(el.children).map(function (k) {
      return k.cloneNode(true);
    });
    var aktiv = false;

    function ryd() {
      el.classList.remove('is-ready');
      el.style.removeProperty('--loop');
      el.style.removeProperty('animation-duration');
      el.innerHTML = '';
      original.forEach(function (k) { el.appendChild(k.cloneNode(true)); });
    }

    function byg() {
      var skal = el.dataset.marqueeAltid === '' || matchMedia('(max-width:1023px)').matches;
      ryd();
      if (!skal || reduced) { aktiv = false; return; }
      var cs = getComputedStyle(el);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var beholder = el.parentElement ? el.parentElement.clientWidth : innerWidth;

      if (beholder < 1) return;
      var bred = 0;
      for (var n = 0; n < el.children.length; n++) {
        bred += el.children[n].getBoundingClientRect().width;
      }
      if (bred < 1) return;
      var set = bred + gap * el.children.length;
      var need = beholder + set + 8;
      for (var i = 0; i < 24 && el.scrollWidth < need; i++) {
        original.forEach(function (k) { el.appendChild(k.cloneNode(true)); });
      }
      el.style.setProperty('--loop', set + 'px');
      el.style.animationDuration = Math.max(18, Math.round(set / pps)) + 's';
      aktiv = true;
      requestAnimationFrame(function () { el.classList.add('is-ready'); });
    }

    byg();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(byg);
    var t;
    addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(byg, 200);
    }, { passive: true });

    addEventListener('overlay:aaben', function (e) {
      if (e.detail && e.detail.contains(el)) byg();
    });
  }
  $$('[data-marquee]').forEach(function (el) { loop(el, 42); });

  
  function stilleFokus(el) {
    if (!el) return;
    el.setAttribute('data-quiet', '');
    var af = function () {
      el.removeAttribute('data-quiet');
      el.removeEventListener('blur', af); el.removeEventListener('keydown', af);
    };
    el.addEventListener('blur', af); el.addEventListener('keydown', af);
    el.focus({ preventScroll: true });
  }

  function overlay(rod, aabnere, lukkere) {
    if (!rod) return null;
    var sidst = null;
    function aaben(fra) {
      sidst = fra || document.activeElement;
      rod.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('har-overlay');

      dispatchEvent(new CustomEvent('overlay:aaben', { detail: rod }));
      requestAnimationFrame(function () {
        rod.classList.add('is-on');
        stilleFokus(rod.querySelector('[data-luk-fokus], button, a, input'));
      });
    }
    function luk() {
      rod.classList.remove('is-on');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('har-overlay');
      setTimeout(function () { rod.hidden = true; }, 320);
      stilleFokus(sidst);
      dispatchEvent(new CustomEvent('overlay:luk', { detail: rod }));
    }
    aabnere.forEach(function (b) { b.addEventListener('click', function () { aaben(b); }); });
    lukkere.forEach(function (b) { b.addEventListener('click', luk); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !rod.hidden) luk();
    });
    return { aaben: aaben, luk: luk };
  }

  var mm = document.querySelector('[data-mm]');
  overlay(mm, $$('[data-menu-open]'), $$('[data-mm-luk]', mm || document));
  // The drawer's inner markup is re-rendered after every cart change, so its close buttons are
  // handled by delegation instead of being bound once.
  var kurv = document.querySelector('[data-kurv]');
  var kurvOverlay = overlay(kurv, $$('[data-kurv-open]'), []);
  if (kurv) {
    kurv.addEventListener('click', function (e) {
      if (e.target.closest('[data-kurv-luk]')) kurvOverlay.luk();
    });
  }

  if (mm) {
    var stak = ['rod'];

    function vis() {
      var top = stak[stak.length - 1];
      $$('[data-mm-panel]', mm).forEach(function (p) {
        var id = p.getAttribute('data-mm-panel');
        var i = stak.indexOf(id);
        p.classList.toggle('is-paa', id === top);
        p.classList.toggle('is-bag', i > -1 && id !== top);
        p.style.zIndex = i > -1 ? (i + 1) : 0;
        if (id === top) p.scrollTop = 0;
      });
    }
    $$('[data-mm-ind]', mm).forEach(function (b) {
      b.addEventListener('click', function () { stak.push(b.getAttribute('data-mm-ind')); vis(); });
    });
    $$('[data-mm-ud]', mm).forEach(function (b) {
      b.addEventListener('click', function () { if (stak.length > 1) stak.pop(); vis(); });
    });
    vis();
  }

  // Cart drawer. Liquid renders every figure; this only talks to the AJAX cart API and swaps in a
  // fresh render of the hh-cart-drawer section, so drawer prices always match checkout.
  (function () {
    var rod = kurv;
    if (!rod) {
      $$('[data-kurv-open][data-href]').forEach(function (b) {
        b.addEventListener('click', function () { location.href = b.getAttribute('data-href'); });
      });
      return;
    }
    var SECTION = 'hh-cart-drawer';
    var ark = rod.querySelector('[data-kv-ark]');
    var ups = rod.querySelector('[data-ups]');
    var upsHd = rod.querySelector('[data-ups-hd]');
    var upsRul = rod.querySelector('[data-ups-rul]');
    var upsListe = rod.querySelector('[data-ups-liste]');
    var travl = false;

    function krop() { return rod.querySelector('[data-kv-krop]'); }

    // FormData bodies come from the product page: apps that add line properties by patching
    // fetch (the delivery date picker) can append to FormData but would corrupt a JSON string.
    function post(url, body) {
      var fd = body instanceof FormData;
      if (fd) {
        body.append('sections', SECTION);
        body.append('sections_url', location.pathname);
      } else {
        body.sections = SECTION;
        body.sections_url = location.pathname;
      }
      return fetch(url, {
        method: 'POST',
        headers: fd ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: fd ? body : JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      });
    }

    function tegn(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ny = doc.querySelector('[data-kurv]');
      if (!ny) return;
      // The add-on column is filled by Hello Retail, not by Liquid; keep it across renders.
      if (ups.parentElement !== ark) ark.prepend(ups);
      var main = rod.querySelector('[data-kv-main]');
      main.replaceWith(ny.querySelector('[data-kv-main]'));
      rod.classList.toggle('er-tom', ny.classList.contains('er-tom'));
      var antal = rod.querySelector('.kv__top [data-kurv-antal]').textContent.trim();
      // Client standard: no "0" badge on an empty cart.
      $$('[data-kurv-antal]').forEach(function (el) {
        if (!rod.contains(el)) el.textContent = antal === '0' ? '' : antal;
      });
      $$('[data-marquee]', rod).forEach(function (el) { loop(el, 42); });
      placer();
      requestAnimationFrame(toning);
      hentUps();
    }

    function opdater(data) {
      if (data && data.sections && data.sections[SECTION]) tegn(data.sections[SECTION]);
    }

    function hent() {
      return fetch(location.pathname + '?sections=' + SECTION)
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d[SECTION]) tegn(d[SECTION]); });
    }

    function aendr(li, antal) {
      if (travl) return Promise.resolve();
      travl = true;
      rod.setAttribute('aria-busy', 'true');
      return post('/cart/change.js', { id: li.dataset.key, quantity: antal })
        .then(opdater)
        .catch(function () { hent(); })
        .then(function () { travl = false; rod.removeAttribute('aria-busy'); });
    }

    function fjern(li) {
      if (li.dataset.vaek) return;
      li.dataset.vaek = '1';
      li.style.height = li.offsetHeight + 'px';
      void li.offsetHeight;
      li.classList.add('kv__linje--ud');
      li.style.height = '0px';
      setTimeout(function () { aendr(li, 0); }, reduced ? 0 : 340);
    }

    rod.addEventListener('click', function (e) {
      var li = e.target.closest('[data-linje]');
      if (!li || li.dataset.vaek || travl) return;
      var a = parseInt(li.dataset.antal, 10) || 1;
      var min = parseInt(li.dataset.min, 10) || 1;
      if (e.target.closest('[data-op]')) aendr(li, a + 1);
      else if (e.target.closest('[data-ned]')) {
        if (a > min) aendr(li, a - 1); else fjern(li);
      } else if (e.target.closest('[data-fjern]')) fjern(li);
    });

    // Add-ons from Hello Retail: its SDK returns the configured box as JSON, rendered here in the
    // prototype's markup instead of Hello Retail's own template.
    function esc(t) {
      var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML;
    }
    // Formats with the shop's own money format so add-on prices read like the rest of the drawer.
    var format = ups.getAttribute('data-money-format') || '{{amount_with_comma_separator}} kr';
    function kr(n) {
      var d = (Math.round(n * 100) / 100).toFixed(2).split('.');
      var komma = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d[1];
      var punktum = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d[1];
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        return k === 'amount_with_comma_separator' ? komma : k === 'amount_no_decimals' ? d[0] : punktum;
      });
    }
    // Add-ons follow the cart: they are reloaded whenever the set of products in the cart changes, and
    // products already in the cart are never offered. The Liquid fallback list is kept to fall back on.
    var upsSig = null, upsNr = 0;
    var upsFallback = upsListe.innerHTML;
    // The last list per cart is kept for the session, so the next page shows it at once instead of the fallback.
    function upsCache(sig, html) {
      try {
        if (html === undefined) { var c = JSON.parse(sessionStorage.getItem('hh-ups') || 'null'); return c && c.sig === sig ? c.html : null; }
        sessionStorage.setItem('hh-ups', JSON.stringify({ sig: sig, html: html }));
      } catch (e) { return null; }
    }
    function upsVis(html) {
      if (upsListe.innerHTML !== html) upsListe.innerHTML = html;
      ups.hidden = !upsListe.children.length;
      ups.classList.remove('is-laeser');
      placer();
      requestAnimationFrame(toning);
    }
    function kurvUrls() {
      var urls = [];
      $$('[data-linje] a.kv__t[href]', rod).forEach(function (a) {
        var u = new URL(a.getAttribute('href'), location.origin);
        u = u.origin + u.pathname;
        if (urls.indexOf(u) < 0) urls.push(u);
      });
      return urls;
    }
    function sti(u) { try { return new URL(u, location.origin).pathname; } catch (e) { return String(u); } }
    function visFallback(iKurv) {
      var tmp = document.createElement('ul');
      tmp.innerHTML = upsFallback;
      $$('[data-ups-vare]', tmp).forEach(function (li) {
        if (iKurv.indexOf(sti(li.getAttribute('data-url'))) > -1) li.remove();
      });
      upsCache(upsSig, tmp.innerHTML);
      upsVis(tmp.innerHTML);
    }
    function hentUps() {
      var urls = kurvUrls();
      var iKurv = urls.map(sti);
      var sig = iKurv.slice().sort().join('|');
      if (sig === upsSig) return;
      upsSig = sig;
      var gemt = upsCache(sig);
      if (gemt !== null) { upsNr++; upsVis(gemt); return; }
      var key = ups.getAttribute('data-hr-key');
      if (!key) { visFallback(iKurv); return; }
      var nr = ++upsNr;
      // Skeleton rows while loading, so the shopper never sees one list swap for another
      ups.classList.add('is-laeser');
      upsListe.innerHTML = new Array(5).join('<li class="kv__ups-vare kv__ups-skel" aria-hidden="true"><span class="kv__ups-bil"></span><div class="kv__ups-txt"><i></i><i></i></div><span class="kv__ups-add"></span></li>');
      ups.hidden = false;
      placer();
      // The cart's products are the context, so the box can answer with "bought together"
      window.hrq = window.hrq || [];
      window.hrq.push(['loadRecom', [{ key: key, format: 'json', context: { urls: urls } }], function (svar) {
        if (nr !== upsNr) return;
        var produkter = ((svar && svar.responses && svar.responses[0] && svar.responses[0].products) || [])
          .filter(function (p) { return iKurv.indexOf(sti(p.url)) < 0; });
        if (!produkter.length) { visFallback(iKurv); return; }
        // Hello Retail does not know which products are big bags or have variants; ask the theme per product
        // (product.hh-ups template) and keep only in-stock single-variant products that are not big bags.
        Promise.all(produkter.map(function (p) {
          return fetch(String(p.url).split(/[?#]/)[0] + '?view=hh-ups', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (info) { return info && !info.bigbag && info.simple && info.available && info.variant ? Object.assign({}, p, { variant: info.variant }) : null; })
            .catch(function () { return null; });
        })).then(function (liste) {
          if (nr !== upsNr) return;
          liste = liste.filter(Boolean);
          if (liste.length) vis(liste); else visFallback(iKurv);
        });
      }]);
    }
    function vis(produkter) {
        if (!produkter.length) return;
        var tekst = ups.getAttribute('data-add-label') || '';
        var html = produkter.map(function (p) {
          var foer = p.oldPrice && p.oldPrice > p.price ? ' <s>' + kr(p.oldPrice) + '</s>' : '';
          return '<li class="kv__ups-vare" data-ups-vare data-url="' + esc(p.url) + '" data-variant="' + esc(p.variant) + '">' +
            '<span class="kv__ups-bil"><img src="' + esc(p.imgUrl) + '" alt="" width="60" height="60" loading="lazy"></span>' +
            '<div class="kv__ups-txt"><b>' + esc(p.title) + '</b><span class="kv__ups-pris">' + kr(p.price) + foer + '</span></div>' +
            '<button class="kv__ups-add" type="button" data-ups-add aria-label="' + esc(tekst.replace('__TITLE__', p.title)) + '">' +
            '<span class="kv__ups-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.6 8h12.8l-1.1 12H6.7L5.6 8Z"/><path d="M9 8V6.4a3 3 0 0 1 6 0V8"/></svg></span>' +
            '<span class="kv__ups-ok"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5 9 17.5 20 6.5"/></svg></span></button></li>';
        }).join('');
        upsCache(upsSig, html);
        upsVis(html);
    }

    ups.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ups-add]');
      if (!b || b.disabled) return;
      var v = b.closest('[data-ups-vare]');
      var url = v && v.getAttribute('data-url');
      var variantId = v && v.getAttribute('data-variant');
      if (!url && !variantId) return;
      b.disabled = true;
      // Liquid-rendered items carry their variant; Hello Retail items only have a product URL.
      (variantId ? Promise.resolve(variantId) : fetch(url.split(/[?#]/)[0] + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var variant = p.variants.filter(function (x) { return x.available; })[0];
          if (!variant) throw new Error('sold out');
          return variant.id;
        }))
        .then(function (id) { return post('/cart/add.js', { items: [{ id: +id, quantity: 1 }] }); })
        .then(function (d) {
          opdater(d);
          b.classList.add('is-lagt');
          var k = krop();
          if (k) k.scrollTo({ top: k.scrollHeight, behavior: reduced ? 'auto' : 'smooth' });
        })
        .catch(function () {})
        .then(function () {
          setTimeout(function () { b.disabled = false; b.classList.remove('is-lagt'); }, 1400);
        });
    });

    var mq = matchMedia('(max-width:900px)');
    function placer() {
      var k = krop();
      if (mq.matches) { if (k && ups.parentElement !== k) k.appendChild(ups); }
      else if (ups.parentElement !== ark) ark.prepend(ups);
    }
    function toning() {
      if (mq.matches || ups.hidden) { ups.classList.remove('is-rullet', 'is-mere'); return; }
      ups.style.setProperty('--ups-hd', upsHd.offsetHeight + 'px');
      ups.classList.toggle('is-rullet', upsRul.scrollTop > 4);
      ups.classList.toggle('is-mere', upsRul.scrollTop + upsRul.clientHeight < upsRul.scrollHeight - 4);
    }
    // Loaded right away in the background (or taken from the session cache), so opening the drawer never shows the list swapping.
    if (kurvUrls().length) hentUps();
    upsRul.addEventListener('scroll', toning, { passive: true });
    addEventListener('resize', function () { placer(); toning(); }, { passive: true });
    addEventListener('overlay:aaben', function (e) {
      if (e.detail === rod) { hentUps(); placer(); toning(); }
    });

    // Public API for product forms and apps that change the cart.
    window.hhCart = {
      // items: an array of { id, quantity, properties } or a ready FormData
      add: function (items, opts) {
        return post('/cart/add.js', items instanceof FormData ? items : { items: items }).then(function (d) {
          opdater(d);
          if (!opts || opts.open !== false) kurvOverlay.aaben();
          return d;
        });
      },
      refresh: hent,
      open: function () { kurvOverlay.aaben(); }
    };
    document.addEventListener('cart:refresh', hent);

    placer();
  })();

  // Newsletter validation, same rules as on the other Codafweb themes. `novalidate` because the
  // browser's own bubbles are unstyled and say less than the message written for the field.
  $$('form.signup').forEach(function (form) {
    var input = form.querySelector('[data-required]');
    var row = form.querySelector('[data-field]');
    var slot = form.querySelector('[data-error-slot]');
    var trap = form.querySelector('[data-trap]');
    if (!input || !row) return;
    form.setAttribute('novalidate', 'novalidate');

    function setError(message) {
      row.toggleAttribute('data-invalid', !!message);
      if (message) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
      if (slot) slot.textContent = message || '';
    }
    function validate() {
      var value = (input.value || '').trim();
      if (!value) return input.getAttribute('data-error');
      // Loose on purpose: Shopify decides what is deliverable.
      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(value)) return input.getAttribute('data-error-format');
      return null;
    }
    input.addEventListener('input', function () {
      if (row.hasAttribute('data-invalid')) setError(null);
    });
    form.addEventListener('submit', function (e) {
      if (trap && trap.value) { e.preventDefault(); return; }
      var message = validate();
      setError(message);
      if (message) { e.preventDefault(); input.focus(); }
    });
  });

  $$('[data-seo-knap]').forEach(function (knap) {
    var rod = knap.closest('.seo');
    var fold = rod && rod.querySelector('[data-seo-fold]');
    if (!fold) return;
    var krop = fold.firstElementChild;
    var hand = knap.parentElement;

    function maal() {
      if (fold.classList.contains('is-aaben')) return;
      // Short text: no button, and no fade either (the prototype kept the fade over text that fits).
      fold.classList.remove('er-kort');
      var kort = krop.scrollHeight <= fold.clientHeight + 8;
      fold.classList.toggle('er-kort', kort);
      if (kort) hand.style.display = 'none';
      else hand.style.removeProperty('display');
    }

    var loeb = 0;

    function faerdig(f) {
      var mit = ++loeb;
      var kaldt = false;
      function g(e) {
        if (e && (e.target !== fold || e.propertyName !== 'max-height')) return;
        if (kaldt || mit !== loeb) return;
        kaldt = true;
        fold.removeEventListener('transitionend', g);
        f();
      }
      if (reduced) { g(); return; }
      fold.addEventListener('transitionend', g);
      setTimeout(g, 700);
    }

    function aaben() {
      fold.style.maxHeight = krop.scrollHeight + 'px';
      fold.classList.add('is-aaben');
      knap.setAttribute('aria-expanded', 'true');
      faerdig(function () { fold.style.maxHeight = 'none'; });
    }

    function luk() {
      loeb++;
      fold.style.maxHeight = fold.scrollHeight + 'px';
      void fold.offsetHeight;
      fold.classList.remove('is-aaben');
      knap.setAttribute('aria-expanded', 'false');
      fold.style.removeProperty('max-height');

      // The header is sticky, so "above the viewport" means above its bottom edge, and the
      // block scrolls back to just below it (scroll-margin-top in hh-shopify.css).
      var hd = document.querySelector('[data-hd]');
      var hdBund = hd ? hd.getBoundingClientRect().bottom : 0;
      if (rod.getBoundingClientRect().top < hdBund) {
        rod.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    knap.addEventListener('click', function () {
      if (fold.classList.contains('is-aaben')) luk(); else aaben();
    });
    maal();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(maal);
    var mt;
    addEventListener('resize', function () {
      clearTimeout(mt); mt = setTimeout(maal, 200);
    }, { passive: true });
  });


  $$('[data-kar]').forEach(function (track) {
    var rod = track.closest('.kar') || track.closest('section');
    if (!rod) return;
    var prev = rod.querySelector('[data-kar-prev]');
    var next = rod.querySelector('[data-kar-next]');
    var bjaelke = rod.querySelector('[data-kar-bjaelke]');

    function kortbredde() {
      var k = track.firstElementChild;
      if (!k) return track.clientWidth * .8;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return k.getBoundingClientRect().width + gap;
    }
    function skridt(d) {
      var b = kortbredde();
      var n = Math.max(1, Math.floor(track.clientWidth / b));
      track.scrollBy({ left: d * b * n, behavior: reduced ? 'auto' : 'smooth' });
    }

    function pilhoejde() {
      var k = track.firstElementChild;
      if (!k) return;
      var bil = k.querySelector('[data-kar-bil]') || k;
      var r = bil.getBoundingClientRect(), rr = rod.getBoundingClientRect();
      rod.style.setProperty('--pil-y', (r.top - rr.top + r.height / 2) + 'px');
    }
    var spor = rod.querySelector('[data-kar-spor]');
    function sync() {
      var maks = track.scrollWidth - track.clientWidth;

      if (spor) { spor.hidden = maks <= 2; spor.classList.remove('er-ukendt'); }
      rod.classList.toggle('er-hel', maks <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = maks <= 2 || track.scrollLeft >= maks - 2;
      if (bjaelke) {
        var del = Math.min(1, track.clientWidth / track.scrollWidth);
        var pos = maks > 0 ? (track.scrollLeft / maks) : 0;
        bjaelke.style.setProperty('--del', (del * 100) + '%');
        bjaelke.style.setProperty('--pos', (pos * (100 / del - 100)) + '%');
      }
    }
    // Mouse drag on the track. Touch keeps native scrolling; this only handles a mouse, turns
    // snapping off while dragging, adds a short momentum glide and swallows the click that
    // would otherwise follow a drag on a card link.
    var traek = null, slipKlik = false, glid = 0;
    function snapFra() { track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; }
    function snapTil() { track.style.removeProperty('scroll-snap-type'); track.style.removeProperty('scroll-behavior'); }
    // Re-enabling scroll-snap makes the browser jump to the nearest card instantly. Glide there
    // first, then switch snapping back on once the track is already aligned.
    function landPaaKort(fremskudt) {
      // One motion, no correction afterwards: aim at the card nearest to where the throw would
      // have ended, glide there, then switch snapping back on once the track is aligned.
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var base = track.getBoundingClientRect().left + pad;
      var maks = track.scrollWidth - track.clientWidth;
      var mod = Math.max(0, Math.min(maks, track.scrollLeft + (fremskudt || 0)));
      var maal = mod, bd = Infinity;
      Array.prototype.forEach.call(track.children, function (k) {
        var x = k.getBoundingClientRect().left - base + track.scrollLeft;
        if (Math.abs(x - mod) < bd) { bd = Math.abs(x - mod); maal = x; }
      });
      // The last cards can never sit at the left edge, so the end of the track is a stop too;
      // without it a throw towards the end stopped one card short.
      if (Math.abs(maks - mod) < bd) maal = maks;
      maal = Math.max(0, Math.min(maks, maal));
      if (Math.abs(maal - track.scrollLeft) < 1) { snapTil(); return; }
      var faerdig = false;
      var fin = function () {
        if (faerdig) return;
        faerdig = true;
        track.removeEventListener('scrollend', fin);
        snapTil();
      };
      track.addEventListener('scrollend', fin);
      setTimeout(fin, 700);
      track.scrollTo({ left: maal, behavior: reduced ? 'auto' : 'smooth' });
    }
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || rod.classList.contains('er-hel')) return;
      cancelAnimationFrame(glid);
      traek = { x: e.clientX, venstre: track.scrollLeft, sidst: e.clientX, t: performance.now(), v: 0, flyttet: false };
    });
    addEventListener('pointermove', function (e) {
      if (!traek) return;
      var dx = e.clientX - traek.x;
      if (!traek.flyttet && Math.abs(dx) < 5) return;
      if (!traek.flyttet) { traek.flyttet = true; snapFra(); track.classList.add('is-traek'); }
      var nu = performance.now();
      traek.v = (traek.sidst - e.clientX) / Math.max(1, nu - traek.t);
      traek.sidst = e.clientX; traek.t = nu;
      track.scrollLeft = traek.venstre - dx;
    });
    addEventListener('pointerup', function () {
      if (!traek) return;
      var t = traek; traek = null;
      if (!t.flyttet) return;
      slipKlik = true;
      track.classList.remove('is-traek');
      // Throw distance of the old momentum loop (v per frame, decaying by 0.92): v / (1 - 0.92).
      var kast = reduced ? 0 : (t.v * 16) / 0.08;
      landPaaKort(kast);
    });
    track.addEventListener('click', function (e) {
      if (slipKlik) { e.preventDefault(); e.stopPropagation(); slipKlik = false; }
    }, true);

    // The progress bar works as a scrollbar: drag the thumb, or click the rail to jump there.
    var greb = rod.querySelector('[data-kar-greb]');
    if (greb && spor && bjaelke) {
      var bar = null;
      greb.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        var r = spor.getBoundingClientRect(), b = bjaelke.getBoundingClientRect();
        var maks = track.scrollWidth - track.clientWidth;
        if (maks <= 0) return;
        var fri = r.width - b.width;
        if (e.clientX < b.left || e.clientX > b.right) {
          // Click on the rail: centre the thumb under the pointer, then keep dragging from there.
          var maal = Math.min(1, Math.max(0, (e.clientX - r.left - b.width / 2) / fri));
          track.scrollLeft = maal * maks;
        }
        bar = { x: e.clientX, venstre: track.scrollLeft, faktor: maks / fri };
        greb.setPointerCapture(e.pointerId);
        snapFra();
        rod.classList.add('is-bar-traek');
        e.preventDefault();
      });
      greb.addEventListener('pointermove', function (e) {
        if (!bar) return;
        track.scrollLeft = bar.venstre + (e.clientX - bar.x) * bar.faktor;
      });
      function slip() {
        if (!bar) return;
        bar = null; rod.classList.remove('is-bar-traek'); landPaaKort();
      }
      greb.addEventListener('pointerup', slip);
      greb.addEventListener('pointercancel', slip);
    }

    if (prev) prev.addEventListener('click', function () { skridt(-1); });
    if (next) next.addEventListener('click', function () { skridt(1); });
    track.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', function () { sync(); pilhoejde(); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { sync(); pilhoejde(); });
    sync(); pilhoejde();
  });

  // Quick add from product cards. Only single-variant, non-bigbag products get the button
  // (see snippets/hh-product-card.liquid); the minimum quantity rides along.
  function pkAdd(b) {
    if (b.disabled || !window.hhCart) return;
    b.disabled = true;
    b.classList.add('er-travl');
    window.hhCart.add([{ id: +b.getAttribute('data-pk-add'), quantity: +b.getAttribute('data-pk-antal') || 1 }])
      .catch(function () {})
      .then(function () { b.disabled = false; b.classList.remove('er-travl'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pk-add]');
    if (b) pkAdd(b);
  });
  // Collection page. Filtering is server-side (Search & Discovery); the panel, chips and counts
  // keep the prototype's UI. Every change fetches a fresh render of the section and swaps the
  // parts marked data-swap. Filters and sort push a history entry; "load more" only replaces
  // the URL's page parameter, so ?page=N opened directly or via Back restores the same list.
  (function () {
    var gr = document.querySelector('[data-gr]');
    var panel = document.querySelector('[data-fl]');
    if (!gr || !panel) return;
    var sektion = gr.closest('.shopify-section');
    var sectionId = sektion ? sektion.id.replace('shopify-section-', '') : '';
    var bar = document.querySelector('[data-fb]');
    var vagt = document.querySelector('[data-fb-vagt]');
    var GEM = 'hh-kategori-rul';
    var navType = (performance.getEntriesByType('navigation')[0] || {}).type;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    function formular() { return panel.querySelector('[data-fl-form]'); }

    function urlFra(side) {
      var f = formular();
      var p = new URLSearchParams();
      new FormData(f).forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var sort = document.querySelector('[data-sorter]');
      // The collection's default order stays out of the URL, so the canonical URL stays clean.
      if (sort && sort.value !== sort.getAttribute('data-default')) p.set('sort_by', sort.value);
      else p.delete('sort_by');
      if (side > 1) p.set('page', side);
      var q = p.toString();
      return f.getAttribute('action') + (q ? '?' + q : '');
    }

    function hent(url) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }

    function byt(doc) {
      // Groups the shopper had open stay open across the swap.
      var aabne = $$('[data-fg].is-aaben', panel).map(function (g) { return g.getAttribute('data-fg'); });
      // Price bucket counts keep their old numbers until the new ones arrive, so rows do not jump.
      var tal = $$('[data-pris-n]', panel).map(function (n) { return n.textContent; });
      $$('[data-swap]').forEach(function (gammel) {
        var ny = doc.querySelector('[data-swap="' + gammel.getAttribute('data-swap') + '"]');
        if (ny) gammel.replaceWith(document.importNode(ny, true));
      });
      if (aabne.length) {
        $$('[data-fg]', panel).forEach(function (g) {
          var aaben = aabne.indexOf(g.getAttribute('data-fg')) > -1;
          g.classList.toggle('is-aaben', aaben);
          var k = g.querySelector('[data-fg-knap]');
          if (k) k.setAttribute('aria-expanded', aaben ? 'true' : 'false');
        });
      }
      var nyGr = doc.querySelector('[data-gr]');
      if (nyGr) { gr.dataset.side = nyGr.dataset.side; gr.dataset.sider = nyGr.dataset.sider; }
      var nyFl = doc.querySelector('[data-fl]');
      if (nyFl) panel.classList.toggle('har-valg', nyFl.classList.contains('har-valg'));
      maske();
      $$('[data-pris-n]', panel).forEach(function (n, i) { if (tal[i]) n.textContent = tal[i]; });
      prisTal();
    }

    var loeb = 0;
    function anvend(url, push) {
      var mit = ++loeb;
      gr.setAttribute('aria-busy', 'true');
      return hent(url).then(function (doc) {
        if (mit !== loeb) return;
        byt(doc);
        if (push) history.pushState({ hh: 1 }, '', url); else history.replaceState({ hh: 1 }, '', url);
      }).catch(function () {
        if (mit === loeb) location.href = url;
      }).then(function () {
        if (mit === loeb) gr.removeAttribute('aria-busy');
      });
    }

    // Back and forward between filter states: the server render for that URL is the truth.
    addEventListener('popstate', function () { location.reload(); });

    // Price buckets. Shopify takes one price range, so the checked buckets must stay one unbroken
    // run: checking a bucket fills the gap to the run, unchecking one inside the run drops it and
    // everything above it. The run's ends go into the two hidden range fields.
    function prisLoeb(aendret) {
      var boks = aendret.closest('[data-pris]');
      var alle = $$('[data-pris-spand]', boks);
      var ved = alle.indexOf(aendret);
      var paa = alle.map(function (b) { return b.checked; });
      var foerst = paa.indexOf(true), sidst = paa.lastIndexOf(true);
      if (aendret.checked) {
        for (var i = foerst; i <= sidst; i++) alle[i].checked = true;
      } else if (ved > foerst && ved < sidst) {
        for (var j = ved; j <= sidst; j++) alle[j].checked = false;
        sidst = ved - 1;
      }
      foerst = alle.findIndex(function (b) { return b.checked; });
      var ender = foerst < 0 ? ['', ''] : [alle[foerst].getAttribute('data-lo'), alle[sidst].getAttribute('data-hi')];
      boks.querySelector('[data-pris-min]').value = ender[0];
      boks.querySelector('[data-pris-max]').value = ender[1];
    }
    // Per-bucket counts under the other active filters: one small section render per bucket,
    // cached by URL.
    var talCache = {};
    function prisTal() {
      var boks = panel.querySelector('[data-pris]');
      if (!boks) return;
      var minNavn = boks.querySelector('[data-pris-min]').name, maxNavn = boks.querySelector('[data-pris-max]').name;
      var base = new URL(urlFra(1), location.origin);
      base.searchParams.delete(minNavn);
      base.searchParams.delete(maxNavn);
      base.searchParams.delete('sort_by');
      $$('[data-pris-spand]', boks).forEach(function (b) {
        var u = new URL(base);
        if (b.getAttribute('data-lo')) u.searchParams.set(minNavn, b.getAttribute('data-lo'));
        if (b.getAttribute('data-hi')) u.searchParams.set(maxNavn, b.getAttribute('data-hi'));
        u.searchParams.set('section_id', 'hh-collection-count');
        var noegle = u.pathname + u.search;
        var job = talCache[noegle] || (talCache[noegle] = fetch(noegle)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) { var m = t.match(/data-count>(\d+)</); return m ? +m[1] : null; })
          .catch(function () { return null; }));
        job.then(function (n) {
          if (n === null || !b.isConnected) return;
          var raekke = b.closest('.fo');
          raekke.querySelector('[data-pris-n]').textContent = n;
          // An empty bucket cannot be picked, like an empty filter value.
          b.disabled = n === 0 && !b.checked;
          raekke.classList.toggle('er-tom', b.disabled);
        });
      });
    }
    (window.requestIdleCallback || setTimeout)(prisTal);

    panel.addEventListener('change', function (e) {
      if (e.target.matches('[data-pris-spand]')) prisLoeb(e.target);
      if (e.target.matches('input')) anvend(urlFra(1), true);
    });
    panel.addEventListener('submit', function (e) { e.preventDefault(); anvend(urlFra(1), true); });
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-sorter]')) anvend(urlFra(1), true);
    });
    document.addEventListener('click', function (e) {
      var nul = e.target.closest('[data-fl-nulstil]');
      if (!nul || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      anvend(nul.getAttribute('href'), true);
    });

    // Panel, accordion and chips: the prototype's behaviour, delegated because the markup is
    // re-rendered after every change.
    var aabnere = $$('[data-fl-open]');
    var styr = overlay(panel, aabnere, []);
    function saetAaben(v) { aabnere.forEach(function (a) { a.setAttribute('aria-expanded', v); }); }
    aabnere.forEach(function (b) { b.addEventListener('click', function () { saetAaben('true'); }); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-fl-luk]')) { styr.luk(); saetAaben('false'); return; }
      var knap = e.target.closest('[data-fg-knap]');
      if (!knap) return;
      var g = knap.closest('[data-fg]');
      var aaben = !g.classList.contains('is-aaben');
      $$('[data-fg]', panel).forEach(function (a) {
        a.classList.remove('is-aaben');
        a.querySelector('[data-fg-knap]').setAttribute('aria-expanded', 'false');
      });
      if (aaben) { g.classList.add('is-aaben'); knap.setAttribute('aria-expanded', 'true'); }
    });
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-fchip]');
      if (!c) return;
      var g = panel.querySelector('[data-fg="' + c.getAttribute('data-fchip') + '"]');
      if (g && !g.classList.contains('is-aaben')) g.querySelector('[data-fg-knap]').click();
      styr.aaben(c);
      saetAaben('true');
      if (g) setTimeout(function () {
        g.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
      }, 60);
    });

    // Load more: a real link to ?page=N for crawlers and new tabs; here it appends in place.
    function tilfoejSide(side, foran) {
      return hent(urlFra(side)).then(function (doc) {
        var gitter = gr.querySelector('[data-gitter]');
        var nye = $$('[data-gitter] > *', doc).map(function (k) { return document.importNode(k, true); });
        if (foran) {
          var frag = document.createDocumentFragment();
          nye.forEach(function (k) { frag.appendChild(k); });
          gitter.insertBefore(frag, gitter.firstChild);
        } else {
          nye.forEach(function (k) { k.classList.add('pk--ind'); gitter.appendChild(k); });
          void gitter.offsetHeight;
          nye.forEach(function (k) { k.classList.remove('pk--ind'); });
          var mere = gr.querySelector('[data-mere]');
          var nyMere = doc.querySelector('[data-mere]');
          if (mere && nyMere) mere.replaceWith(document.importNode(nyMere, true));
        }
        return doc;
      });
    }
    gr.addEventListener('click', function (e) {
      var knap = e.target.closest('[data-mere-knap]');
      if (!knap || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (knap.getAttribute('aria-busy')) return;
      knap.setAttribute('aria-busy', 'true');
      var side = (parseInt(gr.dataset.side, 10) || 1) + 1;
      tilfoejSide(side, false).then(function () {
        gr.dataset.side = side;
        history.replaceState({ hh: 1 }, '', urlFra(side));
      }).catch(function () { location.href = knap.href; });
    });

    // Scroll position for Back from a product page. bfcache restores it on its own; this covers
    // the case where the page is rendered again.
    function gem() {
      try { sessionStorage.setItem(GEM, JSON.stringify({ url: location.href, y: scrollY })); } catch (err) { /* private mode */ }
    }
    addEventListener('pagehide', gem);
    gr.addEventListener('click', function (e) { if (e.target.closest('a[href*="/products/"]')) gem(); });

    function genskab() {
      var gemt = null;
      try { gemt = JSON.parse(sessionStorage.getItem(GEM) || 'null'); } catch (err) { /* ignore */ }
      if (navType === 'back_forward' && gemt && gemt.url === location.href) scrollTo(0, gemt.y);
    }

    // Opened directly on ?page=N: the pages before it are fetched and put in front, so the list
    // is the same one the shopper had built with "load more".
    var start = parseInt(gr.dataset.side, 10) || 1;
    if (start > 1) {
      var kaede = Promise.resolve();
      for (var s = start - 1; s >= 1; s--) {
        (function (side) { kaede = kaede.then(function () { return tilfoejSide(side, true); }); })(s);
      }
      kaede.then(genskab, genskab);
    } else {
      genskab();
    }

    // Sticky filter bar and the fade masks on the chip row, as in the prototype.
    function fast() {
      if (!vagt || !bar) return;
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hd-h')) || 0;
      bar.classList.toggle('er-fast', vagt.getBoundingClientRect().top <= h + 1);
    }
    function maske() {
      var rul = document.querySelector('[data-fb-rul]');
      if (!rul) return;
      var maks = rul.scrollWidth - rul.clientWidth;
      rul.classList.toggle('er-hel', maks <= 2);
      rul.classList.toggle('er-rullet', maks > 2 && rul.scrollLeft > 4 && rul.scrollLeft < maks - 4);
      rul.classList.toggle('er-slut', maks > 2 && rul.scrollLeft >= maks - 4);
    }
    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-fb-rul]')) maske();
    }, { capture: true, passive: true });
    addEventListener('scroll', fast, { passive: true });
    addEventListener('resize', function () { maske(); fast(); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(maske);
    maske(); fast();
  })();

  // Breadcrumb fade masks: rendered as fitting (er-hel), switched only if the trail overflows.
  $$('[data-brk]').forEach(function (el) {
    function maske() {
      var maks = el.scrollWidth - el.clientWidth;
      el.classList.toggle('er-hel', maks <= 2);
      el.classList.toggle('er-rullet', maks > 2 && el.scrollLeft > 4 && el.scrollLeft < maks - 4);
      el.classList.toggle('er-slut', maks > 2 && el.scrollLeft >= maks - 4);
    }
    el.addEventListener('scroll', maske, { passive: true });
    addEventListener('resize', maske, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(maske);
    maske();
  });

  // Product gallery and lightbox, ported from the prototype.
  (function () {
    var ga = document.querySelector('[data-ga]');
    if (ga) {
      var spor = ga.querySelector('[data-ga-spor]');
      var billeder = $$('[data-ga-s]', spor);
      var zoom = ga.querySelector('[data-ga-zoom]');
      var miniRaekke = ga.querySelector('[data-ga-thumbs]');
      var nu = 0, sidstFulgt = -1;

      function foelg(i) {
        var t = miniRaekke && miniRaekke.querySelector('[data-ga-t="' + i + '"]');
        if (!t || miniRaekke.scrollWidth <= miniRaekke.clientWidth + 1) return;
        var cs = getComputedStyle(miniRaekke);
        var pad = parseFloat(cs.paddingLeft) || 0;
        var gap = parseFloat(cs.columnGap) || 0;
        var rr = miniRaekke.getBoundingClientRect();
        function x(el) { return el.getBoundingClientRect().left - rr.left + miniRaekke.scrollLeft; }
        var buf = t.offsetWidth + gap;
        var fra = miniRaekke.scrollLeft + pad, til = miniRaekke.scrollLeft + miniRaekke.clientWidth - pad;
        var tx = x(t);
        if (tx - buf >= fra - 1 && tx + t.offsetWidth + buf <= til + 1) return;
        var anker = miniRaekke.querySelector('[data-ga-t="' + Math.max(0, i - 1) + '"]');
        miniRaekke.scrollTo({ left: Math.max(0, x(anker) - pad), behavior: reduced ? 'auto' : 'smooth' });
      }

      // Product videos: the poster stays over the video with a spinner until frames actually play
      // ('playing', the one signal every browser incl. iOS Safari gives once it renders), then fades
      // out. A stall brings the spinner back. At the end the video stops on its last frame with a
      // replay button instead of looping. Leaving the slide resets it to the poster.
      function vk(v) {
        if (v._vk) return v._vk;
        var w = v.parentNode;
        v.loop = false;
        w.classList.add('vk');
        var src = v.getAttribute('poster');
        if (src) {
          var po = document.createElement('img');
          po.className = 'vk__poster'; po.src = src; po.alt = ''; po.setAttribute('aria-hidden', 'true');
          w.appendChild(po);
        }
        var sp = document.createElement('span');
        sp.className = 'vk__spin'; sp.setAttribute('aria-hidden', 'true');
        w.appendChild(sp);
        var igen = document.createElement('button');
        igen.type = 'button'; igen.className = 'vk__igen';
        igen.setAttribute('aria-label', ga.getAttribute('data-t-replay') || '');
        igen.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 12a7.5 7.5 0 1 0 2.2-5.3M4.5 4.5v3.7h3.7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        w.appendChild(igen);
        var aktiv = false;
        // The first second of playback often stalls while the file buffers. The poster and spinner are
        // held for at least HOLD ms: the video buffers paused on its first frame, then starts from 0.
        var HOLD = 2000, holdTil = 0, holdTimer = null;
        v.addEventListener('playing', function () {
          if (Date.now() < holdTil) {
            v.pause();
            clearTimeout(holdTimer);
            holdTimer = setTimeout(function () {
              holdTil = 0;
              if (!aktiv) return;
              try { v.currentTime = 0; } catch (e) { /* not seekable yet */ }
              var s = v.play(); if (s && s.catch) s.catch(function () {});
            }, holdTil - Date.now());
            return;
          }
          w.classList.remove('vk--load'); w.classList.add('vk--klar');
        });
        v.addEventListener('waiting', function () { if (aktiv) w.classList.add('vk--load'); });
        v.addEventListener('ended', function () { w.classList.remove('vk--load'); w.classList.add('vk--slut'); });
        function start() {
          aktiv = true;
          w.classList.remove('vk--slut');
          // Hold only on the first start of a slide; a replay of a buffered video starts at once
          if (!w.classList.contains('vk--klar') && v.readyState < 4) holdTil = Date.now() + HOLD;
          if (v.readyState < 3 || holdTil) w.classList.add('vk--load');
          var s = v.play(); if (s && s.catch) s.catch(function () { w.classList.remove('vk--load'); });
        }
        function stop() {
          aktiv = false;
          holdTil = 0; clearTimeout(holdTimer);
          v.pause();
          try { v.currentTime = 0; } catch (e) { /* not loaded yet */ }
          w.classList.remove('vk--load', 'vk--klar', 'vk--slut');
        }
        igen.addEventListener('click', function (e) {
          e.stopPropagation();
          try { v.currentTime = 0; } catch (err) { /* not loaded yet */ }
          start();
        });
        v._vk = { start: start, stop: stop };
        return v._vk;
      }
      function spil(rod, aktiv) {
        $$('video', rod).forEach(function (v) {
          var paa = v.closest('[data-ga-s],.lb__s') === aktiv;
          if (paa) vk(v).start(); else if (v._vk || !v.paused) vk(v).stop();
        });
      }
      // Poster overlay, spinner and replay button exist from the start (DOM only, nothing loads)
      $$('[data-ga-video] video', ga).forEach(vk);
      $$('[data-ga-video]', ga).forEach(function (d) {
        var v = d.querySelector('video');
        d.addEventListener('mouseenter', function () { v.controls = true; });
        d.addEventListener('mouseleave', function () { v.controls = false; });
      });

      function skridt() {
        var f = billeder[0];
        return f ? f.getBoundingClientRect().width + 12 : spor.clientWidth;
      }
      function sync() {
        var maks = spor.scrollWidth - spor.clientWidth;
        nu = Math.round(spor.scrollLeft / Math.max(1, skridt()));
        $$('[data-ga-t]').forEach(function (t) { t.classList.toggle('er-paa', +t.dataset.gaT === nu); });
        if (nu !== sidstFulgt) { sidstFulgt = nu; foelg(nu); }
        if (lbLukket()) spil(spor, billeder[nu]);
        var p = ga.querySelector('[data-ga-n="-1"]'), n = ga.querySelector('[data-ga-n="1"]');
        if (p) p.disabled = spor.scrollLeft <= 4;
        if (n) n.disabled = maks <= 4 || spor.scrollLeft >= maks - 4;

        // On phones the last slide sits further right (no next slide peeks in), so the zoom button
        // and the label follow the scroll over the last step instead of fading out and back in.
        // From where the second to last slide rests to the end; that last step is shorter than a
        // full one, so it cannot be counted back from the end.
        var fra = Math.max(0, billeder.length - 2) * skridt();
        var skub = maks <= 4 || maks <= fra ? 1 : Math.min(1, Math.max(0, (spor.scrollLeft - fra) / (maks - fra)));
        spor.parentNode.style.setProperty('--ga-skub', skub.toFixed(3));
      }
      function vis(i) {
        spor.scrollTo({ left: Math.max(0, i) * skridt(), behavior: reduced ? 'auto' : 'smooth' });
      }
      $$('[data-ga-t]').forEach(function (t) {
        t.addEventListener('click', function () { vis(+t.dataset.gaT); });
      });
      $$('[data-ga-n]', ga).forEach(function (b) {
        b.addEventListener('click', function () { vis(nu + (+b.dataset.gaN)); });
      });
      var lb = document.querySelector('[data-lb]');
      function lbLukket() { return !lb || lb.hidden; }

      spor.addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', sync, { passive: true });
      sync();

      if (lb) {
        var lbSpor = lb.querySelector('[data-lb-spor]');
        var lbMini = lb.querySelector('[data-lb-mini]');
        var lbTael = lb.querySelector('[data-lb-tael]');
        var lbStyr = overlay(lb, [], $$('[data-lb-luk]', lb));
        var bygget = false, lbNu = 0;

        function lbSkridt() { return lbSpor.clientWidth; }
        function lbSync() {
          lbNu = Math.round(lbSpor.scrollLeft / Math.max(1, lbSkridt()));
          if (lbTael) lbTael.textContent = (lb.querySelector('[data-lb-tael-tekst]').getAttribute('data-lb-tael-tekst') || '__I__ / __N__').replace('__I__', lbNu + 1).replace('__N__', billeder.length);
          $$('[data-lb-t]', lb).forEach(function (t) { t.classList.toggle('er-paa', +t.dataset.lbT === lbNu); });
          spil(lbSpor, lbSpor.children[lbNu]);
          var p = lb.querySelector('[data-lb-n="-1"]'), n = lb.querySelector('[data-lb-n="1"]');
          if (p) p.disabled = lbNu <= 0;
          if (n) n.disabled = lbNu >= billeder.length - 1;
        }
        function lbVis(i, blidt) {
          lbSpor.scrollTo({ left: Math.max(0, Math.min(billeder.length - 1, i)) * lbSkridt(),
                            behavior: (blidt && !reduced) ? 'smooth' : 'auto' });
        }
        function byg() {
          if (bygget) return;
          billeder.forEach(function (d, i) {
            var w = document.createElement('div');
            w.className = 'lb__s';
            var kilde = d.querySelector('video');
            var t = document.createElement('button');
            t.type = 'button'; t.className = 'lb__t'; t.setAttribute('data-lb-t', i);
            if (kilde) {
              var sv = document.createElement('video');
              sv.className = 'lb__vid'; sv.src = kilde.getAttribute('src');
              // iOS Safari draws no first frame for preload="metadata", so the poster is passed on
              var poster = kilde.getAttribute('poster');
              if (poster) sv.poster = poster;
              sv.muted = true; sv.playsInline = true; sv.preload = 'none';
              w.className = 'lb__s lb__s--v';
              w.appendChild(sv); lbSpor.appendChild(w);
              w.addEventListener('mouseenter', function () { sv.controls = true; });
              w.addEventListener('mouseleave', function () { sv.controls = false; });
              t.className = 'lb__t lb__t--v';
              t.setAttribute('aria-label', 'Vis video');
              var mv;
              if (poster) {
                mv = document.createElement('img');
                mv.src = poster; mv.alt = ''; mv.loading = 'lazy';
              } else {
                mv = document.createElement('video');
                mv.src = kilde.getAttribute('src'); mv.muted = true;
                mv.playsInline = true; mv.preload = 'metadata';
              }
              var ov = document.createElement('span');
              ov.className = 'lb__tv';
              ov.innerHTML = ga.querySelector('[data-ga-afspil]').innerHTML;
              t.appendChild(mv); t.appendChild(ov);
            } else {
              var im = d.querySelector('img').cloneNode(true);
              im.removeAttribute('width'); im.removeAttribute('height');
              im.setAttribute('src', im.getAttribute('src').replace(/width=\d+/, 'width=1600'));
              w.appendChild(im); lbSpor.appendChild(w);
              t.setAttribute('aria-label', 'Vis billede ' + (i + 1));
              var mi = d.querySelector('img').cloneNode(true);
              mi.setAttribute('src', mi.getAttribute('src').replace(/width=\d+/, 'width=200'));
              t.appendChild(mi);
            }
            lbMini.appendChild(t);
            t.addEventListener('click', function () { lbVis(i, true); });
          });
          lbSpor.addEventListener('scroll', lbSync, { passive: true });

          lbSpor.addEventListener('click', function (e) {
            if (e.target.tagName !== 'IMG' && e.target.tagName !== 'VIDEO') lbStyr.luk();
          });
          $$('[data-lb-n]', lb).forEach(function (b) {
            b.addEventListener('click', function () { lbVis(lbNu + (+b.dataset.lbN), true); });
          });
          bygget = true;
        }
        function aabenLb() {
          byg();
          spil(spor, null);
          lbStyr.aaben(zoom);
          lbVis(nu, false);
          lbSync();
        }
        if (zoom) zoom.addEventListener('click', aabenLb);
        billeder.forEach(function (d) {
          if (!d.hasAttribute('data-ga-video')) d.addEventListener('click', aabenLb);
        });
        addEventListener('overlay:luk', function (ev) {
          if (ev.detail !== lb) return;
          spil(lbSpor, null);
          spil(spor, billeder[nu]);
        });

        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); lbVis(lbNu + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); lbVis(lbNu - 1, true); }
        });
      }
    }
  })();

  // Accordions (product description, specifications, Q&A), as in the prototype.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ak-knap]');
    if (!b) return;
    var a = b.closest('[data-ak]');
    var aaben = a.classList.toggle('is-aaben');
    b.setAttribute('aria-expanded', aaben ? 'true' : 'false');
    var gruppe = a.getAttribute('data-ak-gruppe');
    if (!aaben || !gruppe) return;
    $$('[data-ak-gruppe="' + gruppe + '"]').forEach(function (x) {
      if (x === a || !x.classList.contains('is-aaben')) return;
      x.classList.remove('is-aaben');
      var k = x.querySelector('[data-ak-knap]');
      if (k) k.setAttribute('aria-expanded', 'false');
    });
  });

  // Videos inside an overlay (the delivery popup) start when it opens and pause when it closes,
  // so they are not downloaded with the page.
  addEventListener('overlay:aaben', function (e) {
    $$('video[data-hh-autoplay]', e.detail).forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  });
  addEventListener('overlay:luk', function (e) {
    $$('video', e.detail).forEach(function (v) { v.pause(); });
  });

  // Popups (ask a question, calculator, delivery info).
  $$('[data-pop]').forEach(function (pop) {
    var navn = pop.dataset.pop;
    overlay(pop, $$('[data-pop-open="' + navn + '"]'), $$('[data-pop-luk]', pop));
    // A contact form that was just submitted reopens so the shopper sees the confirmation.
    if (pop.querySelector('form') && location.hash === '#' + pop.querySelector('form').id) {
      var o = $$('[data-pop-open="' + navn + '"]')[0];
      if (o) o.click();
    }
  });

  // Product page buy box. Variants, prices and rules come from the JSON Liquid renders; the
  // behaviour is the prototype's, with the live store's rules on top: a delivery method must be
  // chosen for big bags, 2000 litre/kg variants only allow Mobiltruck, minimum quantities hold.
  (function () {
    var kb = document.querySelector('[data-kb]');
    var dataEl = document.querySelector('[data-kb-data]');
    if (!kb || !dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var T = function (k) { return kb.getAttribute('data-t-' + k) || ''; };

    function kr(cents) {
      var n = cents / 100;
      var d = (Math.round(n * 100) / 100).toFixed(2).split('.');
      var komma = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d[1];
      var punktum = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d[1];
      return (D.moneyFormat || '{{amount_with_comma_separator}} kr').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        return k === 'amount_with_comma_separator' ? komma : k === 'amount_no_decimals' ? d[0] : punktum;
      });
    }

    // Volume tiers. Discount Mixer's app embed prints its storefront config (every volume campaign
    // with its product, variant, collection and tag filters); the campaign matching the selected
    // variant decides the table and the price maths, so the theme never drifts from the discount
    // the app grants in the cart. The theme setting is only the fallback for when the embed is off.
    var dm = null;
    try {
      var dmEl = document.querySelector('script[data-dmixer-config="storefront"]');
      if (dmEl) dm = JSON.parse(dmEl.textContent);
    } catch (e) { dm = null; }
    var settingTiers = (D.tiers || '').split(',').map(function (t) {
      var p = t.trim().split(':'), r = (p[0] || '').split('-');
      var til = +(r[1] || 99);
      // In the setting 99 means "and up"
      return { fra: +r[0], til: til >= 99 ? Infinity : til, pct: parseFloat(p[1]) || 0 };
    }).filter(function (t) { return t.pct > 0 && t.fra > 0; });
    function csv(s) { return String(s || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean); }
    function dmTiers(variantId) {
      var pc = dm.productContext || {};
      var coll = (pc.collectionIds || []).map(String);
      var tags = (pc.tags || []).map(function (t) { return String(t).toLowerCase(); });
      function matches(f) {
        f = f || {};
        return csv(f.vi).indexOf(String(variantId)) > -1 || csv(f.p).indexOf(String(pc.id)) > -1 ||
          csv(f.c).some(function (id) { return coll.indexOf(id) > -1; }) ||
          csv(f.t).some(function (t) { return tags.indexOf(t) > -1; });
      }
      // "e" holds the campaign's exclusions (same shape as the filters): an excluded variant gets no
      // discount in the cart, so it gets no table or reduced price here either.
      var hit = ((dm.campaigns && dm.campaigns.volume) || []).filter(function (c) {
        return matches(c.f) && !matches(c.e);
      })[0];
      // Only percentage tiers ("P") can be shown as "N %"; other campaign types get no table.
      return hit ? hit.t.filter(function (t) { return t.t === 'P' && t.d > 0; }).map(function (t) {
        return { fra: t.l, til: t.h || Infinity, pct: t.d };
      }) : [];
    }
    function tiersFor(variant) {
      if (dm) return dmTiers(variant.id);
      return D.volume ? settingTiers : [];
    }
    var tiers = [];
    // Discount Mixer floors the per-unit discount to whole øre, then multiplies by quantity
    // (checked against /cart.js), so the unit price is rounded the same way here.
    function stkPris(price, pct) { return price - Math.floor(price * pct / 100); }
    function rabat(n) {
      for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].fra && n <= tiers[i].til) return tiers[i].pct;
      return 0;
    }

    var selects = $$('[data-vo]', kb);
    var prisEl = kb.querySelector('[data-kb-pris]');
    var foerEl = kb.querySelector('[data-kb-foer]');
    var rabatEl = kb.querySelector('[data-kb-rabat]');
    var totalEl = kb.querySelector('[data-kb-total]');
    var lagerEl = kb.querySelector('[data-kb-lager]');
    var skuEl = document.querySelector('[data-kb-sku]');
    // Specification rows fed by variant metafields: { variantId: html } plus the product fallback
    var pvEls = $$('[data-kb-pv]').map(function (el) {
      var m = {}; try { m = JSON.parse(el.getAttribute('data-kb-pv')); } catch (e) { m = {}; }
      return { el: el, m: m, fb: el.getAttribute('data-fallback') || '' };
    });
    var antalEl = kb.querySelector('[data-kb-antal]');
    var minEl = kb.querySelector('[data-kb-min]');
    var atc = kb.querySelector('[data-kb-atc]');
    var besked = kb.querySelector('[data-kb-besked]');
    var kbForm = kb.querySelector('[data-kb-form]');
    var idInput = kb.querySelector('[data-kb-id]');
    var antalWrap = kb.querySelector('.kb__antal');
    var restock = kb.querySelector('[data-kb-restock]');
    var restockDato = kb.querySelector('[data-kb-restock-dato]');
    var lm = kb.querySelector('[data-lm]');
    var lmFejl = kb.querySelector('[data-lm-fejl]');
    var mr = kb.querySelector('[data-mr]');
    var mrBody = kb.querySelector('[data-mr-body]');
    var mrNoegle = null;
    function tegnTrin() {
      var noegle = JSON.stringify(tiers);
      if (noegle === mrNoegle || !mr) return;
      mrNoegle = noegle;
      mr.hidden = !tiers.length;
      mrBody.textContent = '';
      tiers.forEach(function (t) {
        var tr = document.createElement('tr');
        tr.setAttribute('data-mr-r', '');
        tr.dataset.mrPct = t.pct;
        [t.til === Infinity ? t.fra + '+' : t.fra === t.til ? String(t.fra) : t.fra + '-' + t.til, t.pct + '\u00a0%', ''].forEach(function (txt, i) {
          var td = document.createElement('td');
          td.textContent = txt;
          if (i === 2) td.setAttribute('data-mr-pris', '');
          tr.appendChild(td);
        });
        mrBody.appendChild(tr);
      });
    }
    var ksPris = document.querySelector('[data-ks-pris]');
    var ksVar = document.querySelector('[data-ks-var]');
    var antal = 1, v = null;

    // Shopify lets the client delete single combinations (60 x 80 cm), while every option still lists all of
    // its values. Each select only offers values that exist together with the choices above it; a value that
    // is gone falls back to the first one that exists.
    function begraens() {
      selects.forEach(function (s, i) {
        if (!i) return;
        var foer = selects.slice(0, i).map(function (x) { return x.value; });
        var findes = {};
        D.variants.forEach(function (x) {
          if (foer.every(function (val, j) { return x.options[j] === val; })) findes[x.options[i]] = 1;
        });
        var foerste = null;
        $$('option', s).forEach(function (o) {
          var ok = !!findes[o.value];
          o.hidden = !ok;
          o.disabled = !ok;
          if (ok && foerste === null) foerste = o.value;
        });
        if (!findes[s.value] && foerste !== null) s.value = foerste;
      });
    }

    function find() {
      begraens();
      var vals = selects.map(function (s) { return s.value; });
      var hit = D.variants.filter(function (x) {
        return x.options.every(function (o, i) { return i >= vals.length || o === vals[i]; });
      })[0];
      if (!hit && vals.length) {
        // The combination does not exist: keep the first choice, move the others to a valid one.
        hit = D.variants.filter(function (x) { return x.options[0] === vals[0]; })[0];
        if (hit) selects.forEach(function (s, i) { s.value = hit.options[i]; });
      }
      return hit || D.variants[0];
    }

    function tegn() {
      v = find();
      tiers = tiersFor(v);
      tegnTrin();
      var min = v.min || 1;
      if (antal < min) antal = min;
      var pct = rabat(antal);
      var stk = stkPris(v.price, pct);
      prisEl.textContent = kr(stk);
      prisEl.classList.toggle('er-nedsat', pct > 0);
      if (foerEl) {
        var foer = pct ? v.price : (v.compare > v.price ? v.compare : 0);
        foerEl.hidden = !foer;
        foerEl.textContent = foer ? kr(foer) : '';
      }
      if (rabatEl) { rabatEl.hidden = !pct; rabatEl.textContent = '−' + pct + ' %'; }
      if (totalEl) {
        // The chosen delivery is added to each bag's line price in the cart, and the volume
        // discount then applies to both, so the total is worked out the same way to match it.
        var levR = lm && lm.querySelector('[data-lm-r]:checked');
        var lev = levR ? +levR.dataset.pris || 0 : 0;
        var sum = (lev ? stkPris(v.price + lev, pct) : stk) * antal;
        totalEl.innerHTML = T(lev ? 'total-lev' : 'total').replace('__N__', antal).replace('__BELOB__', kr(sum));
        totalEl.hidden = !lev && antal < 2;
      }
      if (lagerEl) {
        lagerEl.classList.toggle('er-ude', !v.available);
        // "Udsolgt i denne størrelse" only when another variant is still in stock; a product sold
        // out entirely just says "Udsolgt", as in the prototype's sold-out page.
        lagerEl.lastChild.textContent = v.available ? (D.remote && !D.bigbag ? T('fjern') : T('lager')) : (D.available ? T('ude') : T('ude-alt'));
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      pvEls.forEach(function (p) {
        var html = p.m[v.id] || p.fb;
        p.el.innerHTML = html;
        p.el.parentNode.hidden = !html;
      });
      $$('[data-mr-r]', kb).forEach(function (r) {
        r.querySelector('[data-mr-pris]').textContent = kr(stkPris(v.price, +r.dataset.mrPct));
      });
      if (restock) {
        restock.hidden = v.available || !v.restock;
        if (v.restock) restockDato.innerHTML = T('dato').replace('__DATO__', v.restock);
      }
      if (antalEl) {
        antalEl.min = min;
        if (document.activeElement !== antalEl) antalEl.value = antal;
      }
      if (minEl) {
        minEl.hidden = min <= 1;
        minEl.textContent = T('min').replace('__N__', min);
      }
      if (atc) atc.disabled = !v.available;
      if (idInput) idInput.value = v.id;
      if (besked) {
        besked.setAttribute('data-variant-id', v.id);
        // A sold-out variant of an otherwise available product: the notify button takes the
        // add-to-cart's place, as Cartbite does per variant on the live store.
        if (atc) {
          var ude = !v.available;
          atc.hidden = ude;
          besked.hidden = !ude;
          if (antalWrap) antalWrap.hidden = ude;
          atc.parentNode.classList.toggle('kb__k--besked', ude);
        }
      }
      if (ksPris) ksPris.textContent = prisEl.textContent;
      if (ksVar) {
        ksVar.innerHTML = (D.optionNames || []).map(function (n, i) {
          return '<span><i class="ks__lbl">' + esc(n) + '</i> <b>' + esc(v.options[i] || '') + '</b></span>';
        }).join('');
      }
      if (lm) {
        // Live rule: on 2000 litre / 2000 kg variants only Mobiltruck can deliver.
        var er2000 = /2000\s*(liter|kg)/i.test(v.title);
        lm.toggleAttribute('data-kun-mobiltruck', er2000);
        $$('.lm__r', lm).forEach(function (l) {
          l.hidden = er2000 && !l.hasAttribute('data-lm-mobiltruck');
        });
        if (er2000) {
          var mt = lm.querySelector('[data-lm-mobiltruck] input');
          if (mt && !mt.checked) { mt.checked = true; leveringValgt(); }
        }
      }
      var url = new URL(location.href);
      if (selects.length) {
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
      }
    }

    function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

    function leveringValgt() {
      var r = lm && lm.querySelector('[data-lm-r]:checked');
      if (!r) return;
      if (lmFejl) lmFejl.hidden = true;
      tegn();
    }
    if (lm) lm.addEventListener('change', leveringValgt);

    selects.forEach(function (s) { s.addEventListener('change', tegn); });
    var op = kb.querySelector('[data-kb-op]'), ned = kb.querySelector('[data-kb-ned]');
    if (op) op.addEventListener('click', function () { antal++; tegn(); });
    if (ned) ned.addEventListener('click', function () { if (antal > (v.min || 1)) { antal--; tegn(); } });
    if (antalEl) {
      antalEl.addEventListener('input', function () {
        var n = parseInt(antalEl.value, 10);
        if (!isNaN(n) && n >= 1) { antal = n; tegn(); }
      });
      antalEl.addEventListener('blur', function () {
        var n = parseInt(antalEl.value, 10);
        antal = (isNaN(n) || n < 1) ? 1 : n;
        antalEl.value = antal; tegn();
      });
    }

    // Back in stock: Cartbite reads product, variant and handle from the clicked element's
    // data-* attributes, the same ones its own button carries.
    if (besked) besked.addEventListener('click', function () {
      var gc = window.growConfig;
      if (!gc || typeof gc.stockWidgetClicked !== 'function') return;
      gc.stockWidgetClicked({ target: besked });
      styleCartbite();
    });

    // Without the app's drawer mode (a dashboard setting, see the submit handler above) Custom
    // Price Calculator adds made-to-measure items itself and then sends the browser to /cart.
    // Where the Navigation API exists that redirect is cancelled and the cart drawer opens
    // instead. The app only clears its "checkout in progress" flag on a bfcache pageshow, so one
    // is dispatched to allow a second add.
    var cpcTil = false;
    kb.addEventListener('click', function (e) {
      if (e.target.closest('[data-kb-atc]') && kb.querySelector('#calculator')) cpcTil = true;
    }, true);
    if (window.navigation && window.hhCart) navigation.addEventListener('navigate', function (e) {
      if (!cpcTil || !e.cancelable) return;
      var u = new URL(e.destination.url);
      if (u.origin !== location.origin || !/\/cart\/?$/.test(u.pathname)) return;
      e.preventDefault();
      cpcTil = false;
      $$('.loading-anim-cpc').forEach(function (el) { el.style.display = 'none'; });
      try { window.dispatchEvent(new PageTransitionEvent('pageshow', { persisted: true })); } catch (err) { /* old browser */ }
      Promise.resolve(window.hhCart.refresh()).then(function () { window.hhCart.open(); });
    });

    // Cartbite's popup is a srcdoc iframe (same origin), so it is dressed in the site's fonts and
    // tokens from here; its dashboard is shared with the live store and stays untouched.
    function styleCartbite() {
      var f = document.getElementById('gw-stock-fulfilled-iframe');
      var doc = f && f.contentDocument;
      if (!doc || !doc.head || doc.getElementById('hh-gw')) return;
      var rs = getComputedStyle(document.body);
      var vars = ['--gron', '--ink', '--ink-rgb', '--muted', '--ground', '--ground-h', '--paper', '--line', '--rod',
        '--r', '--t-sm', '--t-base', '--t-xl', '--ease', '--ease-out', '--t-farve', '--ark'].map(function (k) {
        return k + ':' + rs.getPropertyValue(k);
      }).join(';');
      var fonts = '';
      Array.prototype.forEach.call(document.styleSheets, function (sh) {
        try {
          Array.prototype.forEach.call(sh.cssRules, function (r) { if (r.type === 5) fonts += r.cssText + '\n'; });
        } catch (e) { /* cross-origin sheet */ }
      });
      var st = doc.createElement('style');
      st.id = 'hh-gw';
      st.textContent = fonts + [
        ':root{' + vars + '}',
        '*{color:var(--ink)}',
        'body.fade-in{background:rgb(var(--ink-rgb) / .5)!important;font-family:"Archivo",system-ui,sans-serif}',
        '.modal-container{width:min(28rem,calc(100% - 2rem))!important;max-height:calc(100% - 2rem);overflow-y:auto;max-width:none!important;padding:2rem!important;border:0!important;border-radius:var(--r)!important;box-shadow:none!important;background:var(--paper)!important;font-family:"Archivo",system-ui,sans-serif!important;text-align:left}',
        '.modal-title{margin:0 2.5rem 0.5rem 0!important;font-family:"Archivo Expanded","Archivo",system-ui,sans-serif!important;font-size:var(--t-xl)!important;font-weight:700!important;line-height:1.12;letter-spacing:-.016em}',
        '.notification-message,.privacy-text{color:var(--muted)!important;font-size:var(--t-sm)!important;line-height:1.55}',
        '.notification-message{margin:0 0 1.25rem!important}',
        '.privacy-text{margin:0.875rem 0 0!important;text-align:left!important}',
        '.email-input{height:3.125rem!important;margin:0 0 0.75rem!important;padding:0 1rem!important;border:0!important;border-radius:var(--r)!important;background:var(--ground)!important;color:var(--ink)!important;font:inherit!important;font-size:var(--t-base)!important;outline:0}',
        '.email-input:focus-visible{box-shadow:inset 0 0 0 1px var(--ink)}',
        '.notify-button{position:relative;isolation:isolate;width:100%!important;height:3.125rem!important;margin:0!important;padding:0 1.5rem!important;border:0!important;border-radius:var(--r)!important;background:transparent!important;color:var(--paper)!important;font:inherit!important;font-size:var(--t-sm)!important;font-weight:600!important;cursor:pointer}',
        '.notify-button::before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--gron);transition:transform 220ms var(--ease-out)}',
        '@media (hover:hover){.notify-button:hover::before{transform:scale(1.028)}}',
        '.notify-button:active::before{transform:scale(.995)}',
        '.notify-button:focus,.close-icon:focus{outline:0}',
        '.notify-button:focus-visible,.close-icon:focus-visible{outline:2px solid var(--ink);outline-offset:2px}',
        '.close-icon{position:absolute!important;top:1.25rem!important;right:1.25rem!important;float:none!important;margin:0!important;isolation:isolate;display:grid;place-items:center;width:2.75rem!important;height:2.75rem!important;padding:0!important;border:0!important;border-radius:6.1875rem!important;background:transparent!important;font-size:0!important;color:transparent!important;cursor:pointer}',
        '.close-icon::before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--ground);transition:transform 220ms var(--ease-out)}',
        '.close-icon::after{content:"";position:absolute;inset:0;margin:auto;width:1.125rem;height:1.125rem;background:var(--ink);-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272%27 stroke-linecap=%27round%27%3E%3Cpath d=%27M6 6l12 12M18 6 6 18%27/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272%27 stroke-linecap=%27round%27%3E%3Cpath d=%27M6 6l12 12M18 6 6 18%27/%3E%3C/svg%3E") center/contain no-repeat}',
        '@media (hover:hover){.close-icon:hover::before{transform:scale(1.1)}}',
        // Once subscribed the form gives way to the confirmation and a close button.
        '.modal-container:has(.gw-success-message.show-block) :is(.email-input,.notify-button,.privacy-text,small,#variant-container,.notification-message){display:none!important}',
        // The app keeps the hidden confirmation in the flow, which left an empty band under the form
        '.gw-success-message:not(.show-block){display:none!important}',
        // Phones: the same side padding as the theme's own popups
        '@media (max-width:640px){.modal-container{padding:1.25rem var(--ark) 1.5rem!important}.close-icon{top:0.75rem!important;right:0.75rem!important}}',
        '.gw-success-message.show-block{display:grid!important;grid-template-columns:1.5rem minmax(0,1fr);gap:1.25rem 0.625rem;align-items:start;margin:0.25rem 0 0!important;padding:0!important;border:0!important;background:none!important;font-size:var(--t-base)!important;line-height:1.5}',
        '.gw-success-message.show-block::before{content:"";width:1.5rem;height:1.5rem;margin-top:-0.0625rem;background:var(--gron);-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m5 12.5 4.5 4.5L19 7.5%27/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m5 12.5 4.5 4.5L19 7.5%27/%3E%3C/svg%3E") center/contain no-repeat}',
        '.gw-success-message .success-text{color:var(--ink)}',
        '.gw-success-message .close-text{grid-column:1 / -1;position:relative;isolation:isolate;display:flex;align-items:center;justify-content:center;height:3.125rem;margin:0!important;border-radius:var(--r);color:var(--ink)!important;font-size:var(--t-sm);font-weight:600;text-decoration:none}',
        '.gw-success-message .close-text::before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--ground);transition:transform 220ms var(--ease-out),background var(--t-farve) var(--ease)}',
        '@media (hover:hover){.gw-success-message .close-text:hover::before{transform:scale(1.028);background:var(--ground-h)}}',
        '.gw-success-message .close-text:active::before{transform:scale(.995)}',
        'small{display:block;margin:-0.25rem 0 1rem;color:var(--rod)!important;font-size:var(--t-sm);line-height:1.4}',
        '.vs__dropdown-toggle{min-height:3.125rem;border:0!important;border-radius:var(--r)!important;background:var(--ground)!important}',
        '.vs__dropdown-menu{border:0!important;border-radius:var(--r)!important;box-shadow:inset 0 0 0 1px var(--line)!important}',
        '#variant-container{margin-bottom:0.75rem}',
        '@media (prefers-reduced-motion:reduce){.notify-button::before,.close-icon::before,.gw-success-message .close-text::before{transition:none}}'
      ].join('\n');
      doc.head.appendChild(st);

      // The app has one error text for both cases; an empty field gets its own message.
      function fejltekst() {
        var sm = doc.querySelector('.email-input ~ small');
        var inp = doc.querySelector('.email-input');
        if (!sm) return;
        var t = inp && inp.value.trim() ? T('mail-fejl') : T('mail-tom');
        if (t && sm.textContent !== t) sm.textContent = t;
      }
      new MutationObserver(fejltekst).observe(doc.body, { childList: true, subtree: true, characterData: true });
      doc.addEventListener('input', fejltekst);
    }

    // The add button is the form's submit button. Custom Price Calculator swaps it for its own
    // clone on made-to-measure products and handles the add there; this listener only ever runs
    // on the original button, i.e. on every other product.
    if (kbForm) kbForm.addEventListener('submit', function (e) {
      e.preventDefault();
      // Custom Price Calculator's drawer mode: it puts the price token and its properties into
      // the form (temporary data-cpc-temp inputs) and calls requestSubmit(), leaving the add to
      // the theme. The form is read now, before the app removes those inputs.
      if (kbForm.querySelector('[data-cpc-temp]')) {
        var fd = new FormData(kbForm);
        travl(true);
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', body: fd, headers: { Accept: 'application/json' }
        }).then(function (r) { if (!r.ok) throw r; return window.hhCart && window.hhCart.refresh(); })
          .then(function () { travl(false); if (window.hhCart) window.hhCart.open(); })
          .catch(function () { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; });
        return;
      }
      var b = kb.querySelector('[data-kb-atc]');
      if (b) b.click();
    });

    // Made-to-measure products (Custom Price Calculator). The theme setting marks them at render
    // time; for any other product the app's resolve endpoint is asked right away, well before the
    // app gets to it. Until the calculator mounts the list price stays hidden and nothing can be
    // added at the base price; if it never mounts, the product falls back to a normal buy box.
    // Sold out: no form to mount into, so a sold-out product keeps its normal price display.
    if (D.available && !kb.classList.contains('har-cpc') && typeof window.cpcThemeCartType !== 'undefined' && window.Shopify && Shopify.shop) {
      fetch('https://api.custompricecalculator.com/api/v1/calculator/app/resolve?shop=' + encodeURIComponent(Shopify.shop) +
        '&productId=' + D.productId + '&pageUrl=' + encodeURIComponent(location.href))
        .then(function (r) { if (r.status === 200 && !kb.querySelector('#calculator')) kb.classList.add('har-cpc'); })
        .catch(function () {});
    }
    setTimeout(function () {
      if (!kb.querySelector('#calculator')) kb.classList.remove('har-cpc');
    }, 10000);

    // A spinner on the add button, and on the sticky bar's copy of it, while the line is added.
    function travl(paa) {
      [kb.querySelector('[data-kb-atc]'), document.querySelector('[data-ks-atc]')].forEach(function (b) {
        if (b) b.classList.toggle('er-travl', paa);
      });
    }
    if (atc) atc.addEventListener('click', function (e) {
      e.preventDefault();
      if (kb.classList.contains('har-cpc') && !kb.querySelector('#calculator')) return;
      if (atc.disabled || !window.hhCart) return;
      var item = new FormData();
      item.append('id', v.id);
      item.append('quantity', antal);
      if (lm) {
        var r = lm.querySelector('[data-lm-r]:checked');
        if (!r) {
          lmFejl.hidden = false;
          var hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hd-h')) || 0;
          scrollTo({ top: lm.getBoundingClientRect().top + scrollY - hd - 24, behavior: reduced ? 'auto' : 'smooth' });
          return;
        }
        item.append('properties[_delivery_method]', r.value);
      }
      // Line properties that app blocks put into the buy box form (e.g. the delivery date).
      if (kbForm) new FormData(kbForm).forEach(function (val, key) {
        if (key.indexOf('properties[') === 0 && val !== '') item.set(key, val);
      });
      atc.disabled = true;
      travl(true);
      window.hhCart.add(item)
        .catch(function (err) {
          if (minEl) { minEl.hidden = false; minEl.textContent = (err && (err.description || err.message)) || ''; }
        })
        .then(function () { atc.disabled = !v.available; travl(false); });
    });

    // "Ofte tilkøbt": separate add buttons (the prototype's layout); items go in without opening
    // the drawer, the cart count updates.
    kb.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ot-add]');
      if (!b || b.disabled || !window.hhCart) return;
      b.disabled = true;
      window.hhCart.add([{ id: +b.getAttribute('data-ot-add'), quantity: 1 }], { open: false })
        .then(function () { b.classList.add('is-lagt'); }, function () {})
        .then(function () { setTimeout(function () { b.disabled = false; b.classList.remove('is-lagt'); }, 1400); });
    });

    // Description "Læs mere" fold, as in the prototype.
    var pd = kb.querySelector('[data-pd-tekst]');
    var pdKnap = kb.querySelector('[data-pd-knap]');
    if (pd && pdKnap) {
      var pdMaal = function () {
        if (pd.classList.contains('is-aaben')) return;
        pdKnap.parentElement.style.display = pd.scrollHeight <= pd.clientHeight + 8 ? 'none' : '';
      };
      pdKnap.addEventListener('click', function () {
        var aaben = !pd.classList.contains('is-aaben');
        pd.style.maxHeight = pd.scrollHeight + 'px';
        void pd.offsetHeight;
        if (aaben) {
          pd.classList.add('is-aaben');
          pdKnap.setAttribute('aria-expanded', 'true');
          setTimeout(function () { pd.style.maxHeight = 'none'; }, reduced ? 0 : 440);
        } else {
          pd.classList.remove('is-aaben');
          pdKnap.setAttribute('aria-expanded', 'false');
          pd.style.removeProperty('max-height');
        }
      });
      pdMaal();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(pdMaal);
    }

    // Sticky bar: appears once the add button has scrolled away, hides at the footer.
    var ksAtc = document.querySelector('[data-ks-atc]');
    if (ksAtc && atc) ksAtc.addEventListener('click', function () {
      var b = kb.querySelector('[data-kb-atc]') || atc;
      b.click();
    });
    var vaelg = document.querySelector('[data-ks-vaelg]');
    if (vaelg) vaelg.addEventListener('click', function () {
      // Big bags: the open choice is the delivery method (or the variant, if none is picked yet).
      var sel = lm && !lm.querySelector('[data-lm-r]:checked') ? lm.querySelector('[data-lm-r]') : selects[0];
      if (!sel) return;
      var maal = sel.closest('.lm') || sel.closest('.vg') || sel;
      var hd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hd-h')) || 0;
      scrollTo({ top: Math.max(0, maal.getBoundingClientRect().top + scrollY - hd - 24), behavior: reduced ? 'auto' : 'smooth' });
      setTimeout(function () { sel.focus({ preventScroll: true }); }, reduced ? 0 : 420);
    });
    var ks = document.querySelector('[data-ks]');
    if (ks && atc) {
      var fod = document.querySelector('[data-fod]');
      var tjek = function () {
        var r = atc.getBoundingClientRect();
        var naaet = fod && fod.getBoundingClientRect().top <= innerHeight;
        var paa = r.bottom < 0 && !naaet;
        ks.classList.toggle('er-paa', paa);
        // The chat launcher sits in the same corner; lift it above the bar while it is shown.
        document.documentElement.classList.toggle('har-ks', paa);
        if (paa) document.documentElement.style.setProperty('--ks-h', ks.offsetHeight + 'px');
      };
      addEventListener('scroll', tjek, { passive: true });
      addEventListener('resize', tjek, { passive: true });
      tjek();
    }

    // Mængdeberegner: litres per variant come from the variant title ("1000 kg (675 liter)",
    // "1000 liter"); weight only shows when the product has a density.
    var bg = document.querySelector('[data-bg]');
    if (bg) {
      var poser = D.variants.map(function (x) {
        var m = x.title.match(/(\d[\d.]*)\s*liter/i);
        return m ? [x.title, parseFloat(m[1].replace('.', ''))] : null;
      }).filter(Boolean);
      var vf = parseFloat((bg.getAttribute('data-vf') || '').replace(',', '.')) || 0;
      var bgL = bg.querySelector('[data-bg-l]'), bgB = bg.querySelector('[data-bg-b]'), bgT = bg.querySelector('[data-bg-t]');
      var q = function (s) { return document.querySelector(s); };
      var tal = function (el) { var n = parseFloat((el.value || '').replace(',', '.')); return isNaN(n) || n < 0 ? 0 : n; };
      var dk = function (n, d) { return n.toFixed(d).replace('.', ','); };
      var bgTegn = function () {
        var areal = tal(bgL) * tal(bgB), t = tal(bgT);
        var m3 = areal * (t / 100), liter = m3 * 1000;
        q('[data-bg-areal]').textContent = dk(areal, 2);
        q('[data-bg-m3]').textContent = dk(m3, 3);
        if (q('[data-bg-ton]')) q('[data-bg-ton]').textContent = dk(m3 * vf, 2);
        q('[data-bg-liter]').textContent = Math.round(liter).toLocaleString('da-DK');
        var svar = q('[data-bg-svar]');
        if (!areal || !t || !poser.length) { svar.textContent = bg.getAttribute('data-tom'); return; }
        var bedst = poser.map(function (p) {
          var stk = Math.ceil(liter / p[1]);
          return { navn: p[0], stk: stk, rest: p[1] * stk - liter };
        }).sort(function (a, b2) { return a.rest - b2.rest; })[0];
        svar.innerHTML = bg.getAttribute('data-svar')
          .replace('__LITER__', Math.round(liter).toLocaleString('da-DK'))
          .replace('__STK__', bedst.stk)
          .replace('__ENHED__', bedst.stk === 1 ? bg.getAttribute('data-enhed') : bg.getAttribute('data-enheder'))
          .replace('__NAVN__', esc(bedst.navn))
          .replace('__REST__', Math.round(bedst.rest).toLocaleString('da-DK'));
      };
      [bgL, bgB, bgT].forEach(function (el) { el.addEventListener('input', bgTegn); });
      var bgNul = document.querySelector('[data-bg-nulstil]');
      var startDybde = bgT.value;
      if (bgNul) bgNul.addEventListener('click', function () {
        bgL.value = ''; bgB.value = ''; bgT.value = startDybde; bgTegn(); bgL.focus();
      });
      bgTegn();
    }

    tegn();
  })();

  // Product recommendations: filled from Shopify's recommendations endpoint, then the
  // prototype's "Vis flere" (16 more per click, twice at most).
  // Sections are filled one after another, so a later list never repeats a product an earlier
  // one already shows ("Andre kigger også på" and "Ofte købt sammen med" got the same two items).
  var anbVist = {};
  var anbKoe = Promise.resolve();
  // "Often bought together" goes first: its picks are the most specific, so they stay there.
  $$('[data-anb]').sort(function (a, b) { return (b.getAttribute('data-anb-url').indexOf('intent=complementary') > -1) - (a.getAttribute('data-anb-url').indexOf('intent=complementary') > -1); })
    .forEach(function (sek) { anbKoe = anbKoe.then(function () { return fyldAnb(sek); }); });
  function fyldAnb(sek) {
    var reserve = sek.querySelector('[data-anb-reserve]');
    function klar() {
      sek.hidden = false;
      var gitter = sek.querySelector('[data-anb-gitter]');
      var knap = sek.querySelector('[data-anb-mere]');
      var kort = $$('.pk', gitter);
      var SIDE = 16, tryk = 0;
      var kolonner = function () {
        var t = getComputedStyle(gitter).gridTemplateColumns;
        return Math.max(1, t.split(' ').filter(function (x) { return x !== '0px'; }).length);
      };
      var tegnAnb = function (nye) {
        var kol = kolonner();
        var loft = Math.min((tryk + 1) * SIDE, kort.length);
        // Round down to full rows only while more cards remain; the prototype also rounded the
        // last batch, which stranded the remainder behind a button that did nothing.
        if (loft < kort.length) loft = Math.floor(loft / kol) * kol || loft;
        kort.forEach(function (el, i) {
          var vis = i < loft;
          if (vis && el.hidden && nye && !reduced) { el.classList.add('pk--ind'); requestAnimationFrame(function () { el.classList.remove('pk--ind'); }); }
          el.hidden = !vis;
        });
        knap.parentElement.hidden = tryk >= 2 || loft >= kort.length;
      };
      knap.addEventListener('click', function () { tryk++; tegnAnb(true); });
      addEventListener('resize', function () { tegnAnb(false); }, { passive: true });
      tegnAnb(false);
    }
    var gitter = sek.querySelector('[data-anb-gitter]');
    var maks = parseInt(sek.getAttribute('data-anb-total'), 10) || 48;
    var href = function (k) { var a = k.querySelector('.pk__t'); return a ? a.getAttribute('href').split('?')[0] : ''; };
    // Shopify's picks first, then the pool; nothing twice, nothing an earlier list shows.
    function saml(kort) {
      kort.forEach(function (k) {
        var h = href(k);
        if (!h || anbVist[h] || gitter.children.length >= maks) return;
        anbVist[h] = 1;
        gitter.appendChild(document.importNode(k, true));
      });
    }
    return fetch(sek.getAttribute('data-anb-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var ny = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-anb]');
        gitter.innerHTML = '';
        if (ny) saml($$('.pk', ny.querySelector('[data-anb-gitter]')));
      })
      .catch(function () { gitter.innerHTML = ''; })
      .then(function () {
        if (reserve) saml($$('.pk', reserve.content));
        if (gitter.querySelector('.pk')) klar();
      });
  }

  // Article table of contents. Liquid lists the h2 headings with handleized anchors; editor
  // content carries no ids, so each heading takes the anchor of the TOC link with the same text
  // (no second slug algorithm that could disagree with Liquid's handleize).
  (function () {
    var tekst = document.querySelector('[data-ar-tekst]');
    var tocLinks = $$('[data-ai-a]');
    if (tekst && tocLinks.length) {
      var hs = $$('h2', tekst);
      tocLinks.forEach(function (a, i) {
        var id = decodeURIComponent(a.getAttribute('href').slice(1));
        var navn = a.textContent.trim();
        var h = hs.filter(function (x) { return x.textContent.trim() === navn && !x.id; })[0] || hs[i];
        if (h && !h.id) h.id = id;
      });
    }
    var ai = document.querySelector('[data-ai]');
    if (!ai) return;
    var links = $$('[data-ai-a]', ai);
    var knap = ai.querySelector('[data-ai-knap]');
    var mobil = matchMedia('(max-width:1023px)');
    var maal = links.map(function (a) {
      return document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
    });
    function hoved() {
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hd-h')) || 0;
    }
    function aktiv() {
      var graense = hoved() + 48;
      var idx = -1;
      maal.forEach(function (h, i) { if (h && h.getBoundingClientRect().top <= graense) idx = i; });
      links.forEach(function (a, i) {
        a.classList.toggle('er-aktiv', i === idx);
        if (i === idx) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
    }
    function luk() {
      ai.classList.remove('is-aaben');
      if (knap) knap.setAttribute('aria-expanded', 'false');
    }
    if (knap) knap.addEventListener('click', function () {
      var aaben = ai.classList.toggle('is-aaben');
      knap.setAttribute('aria-expanded', aaben ? 'true' : 'false');
    });
    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        var h = maal[i];
        if (!h) return;
        e.preventDefault();
        if (mobil.matches) luk();
        h.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
      });
    });
    addEventListener('scroll', aktiv, { passive: true });
    addEventListener('resize', aktiv, { passive: true });
    aktiv();
  })();

  // Copy link / native share on touch devices, as in the prototype.
  (function () {
    var d = document.querySelector('[data-del]');
    if (!d) return;
    var t = d.querySelector('[data-del-t]');
    var hvile = t.textContent;
    var nativ = !!navigator.share && matchMedia('(hover:none)').matches;
    var tid;
    if (nativ) { hvile = d.getAttribute('data-t-del'); t.textContent = hvile; }
    function kvitter() {
      d.classList.add('er-kopieret');
      t.textContent = d.getAttribute('data-t-kopieret');
      clearTimeout(tid);
      tid = setTimeout(function () { d.classList.remove('er-kopieret'); t.textContent = hvile; }, 2200);
    }
    function reserve(url) {
      var f = document.createElement('textarea');
      f.value = url; f.setAttribute('readonly', '');
      f.style.position = 'fixed'; f.style.opacity = '0';
      document.body.appendChild(f); f.select();
      try { document.execCommand('copy'); } catch (err) { /* nothing else to try */ }
      document.body.removeChild(f);
      kvitter();
    }
    d.addEventListener('click', function () {
      var url = location.href.split('#')[0];
      if (nativ) {
        var h1 = document.querySelector('h1');
        navigator.share({ title: h1 ? h1.textContent.trim() : document.title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(kvitter, function () { reserve(url); });
      } else reserve(url);
    });
  })();

  // "Load more" on listings without a filter panel (guides): same rules as collections, a real
  // ?page=N link, previous pages restored on a direct visit, scroll restored on Back.
  (function () {
    var gr = document.querySelector('[data-gr]');
    if (!gr || document.querySelector('[data-fl]')) return;
    var sektion = gr.closest('.shopify-section');
    var sectionId = sektion ? sektion.id.replace('shopify-section-', '') : '';
    var GEM = 'hh-liste-rul';
    var navType = (performance.getEntriesByType('navigation')[0] || {}).type;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    function sideUrl(side) {
      var u = new URL(location.href);
      if (side > 1) u.searchParams.set('page', side); else u.searchParams.delete('page');
      return u.pathname + u.search;
    }
    function hent(side) {
      var u = new URL(sideUrl(side), location.origin);
      u.searchParams.set('section_id', sectionId);
      return fetch(u).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    }
    function tilfoej(side, foran) {
      return hent(side).then(function (doc) {
        var gitter = gr.querySelector('[data-gitter]');
        var nye = $$('[data-gitter] > *', doc).map(function (k) { return document.importNode(k, true); });
        if (foran) {
          // Page 1 also has the large cards above the grid; put them back on a direct visit.
          if (side === 1 && !document.querySelector('.gl') && doc.querySelector('.gl')) {
            // Right above the grid: the hero lives in the same section, so inserting before the
            // section would put the cards above the hero.
            gr.parentNode.insertBefore(document.importNode(doc.querySelector('.gl'), true), gr);
          }
          var frag = document.createDocumentFragment();
          nye.forEach(function (k) { frag.appendChild(k); });
          gitter.insertBefore(frag, gitter.firstChild);
        } else {
          nye.forEach(function (k) { gitter.appendChild(k); });
          var mere = gr.querySelector('[data-mere]'), nyMere = doc.querySelector('[data-mere]');
          if (mere && nyMere) mere.replaceWith(document.importNode(nyMere, true));
        }
      });
    }
    gr.addEventListener('click', function (e) {
      var knap = e.target.closest('[data-mere-knap]');
      if (!knap || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (knap.getAttribute('aria-busy')) return;
      knap.setAttribute('aria-busy', 'true');
      var side = (parseInt(gr.dataset.side, 10) || 1) + 1;
      tilfoej(side, false).then(function () {
        gr.dataset.side = side;
        history.replaceState(history.state, '', sideUrl(side));
      }).catch(function () { location.href = knap.href; });
    });
    function gem() {
      try { sessionStorage.setItem(GEM, JSON.stringify({ url: location.href, y: scrollY })); } catch (err) { /* private mode */ }
    }
    addEventListener('pagehide', gem);
    document.addEventListener('click', function (e) { if (e.target.closest('a[href]')) gem(); });
    function genskab() {
      var g = null;
      try { g = JSON.parse(sessionStorage.getItem(GEM) || 'null'); } catch (err) { /* ignore */ }
      if (navType === 'back_forward' && g && g.url === location.href) scrollTo(0, g.y);
    }
    var start = parseInt(gr.dataset.side, 10) || 1;
    if (start > 1) {
      var kaede = Promise.resolve();
      for (var s = start - 1; s >= 1; s--) {
        (function (side) { kaede = kaede.then(function () { return tilfoej(side, true); }); })(s);
      }
      kaede.then(genskab, genskab);
    } else genskab();
  })();

  // Cart page: the drawer's quantity controls, applied through the AJAX cart API. The page section
  // and the drawer (with the header badge) are both re-rendered so they never disagree.
  (function () {
    var side = document.querySelector('[data-kurv-side]');
    if (!side) return;
    var id = side.getAttribute('data-section');
    var travl = false;
    function aendr(li, antal) {
      if (travl) return;
      travl = true;
      side.setAttribute('aria-busy', 'true');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: li.dataset.key, quantity: antal, sections: id, sections_url: location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var html = d.sections && d.sections[id];
          if (!html) { location.reload(); return; }
          var ny = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kurv-side]');
          if (ny) side.innerHTML = ny.innerHTML;
          if (window.hhCart) window.hhCart.refresh();
        })
        .catch(function () { location.reload(); })
        .then(function () { travl = false; side.removeAttribute('aria-busy'); });
    }
    // Quick add from the add-on carousel below: the lines are right here, so the page is redrawn
    // instead of opening the drawer over it.
    function tegnSide() {
      return fetch(location.pathname + '?sections=' + id)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ny = d[id] && new DOMParser().parseFromString(d[id], 'text/html').querySelector('[data-kurv-side]');
          if (ny) side.innerHTML = ny.innerHTML;
        });
    }
    if (window.hhCart) {
      var add = window.hhCart.add;
      window.hhCart.add = function (items) {
        return add(items, { open: false }).then(function (d) { tegnSide(); return d; });
      };
    }
    side.addEventListener('click', function (e) {
      var li = e.target.closest('[data-linje]');
      if (!li || travl) return;
      var a = parseInt(li.dataset.antal, 10) || 1;
      var min = parseInt(li.dataset.min, 10) || 1;
      if (e.target.closest('[data-op]')) aendr(li, a + 1);
      else if (e.target.closest('[data-ned]')) aendr(li, a > min ? a - 1 : 0);
      else if (e.target.closest('[data-fjern]')) aendr(li, 0);
    });
  })();

  var hrKort = (function () {
    var el = document.querySelector('[data-hr-kort]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  })();
  // The search overlay's template prints a placeholder per result; each is filled with the
  // collection card (sections/hh-search-cards.liquid). Links keep Hello Retail's #aw_source, which
  // is how it attributes the visit.
  var hrKortCache = {};
  var hrKoe = [];
  var hrKoeTimer = null;
  function hrIndsaet(felt, html) {
    if (!felt.isConnected) return;
    if (html) {
      felt.innerHTML = html;
      var url = new URL(felt.getAttribute('data-url'), location.origin);
      felt.querySelectorAll('a[href]').forEach(function (a) { if (a.pathname === url.pathname) a.href = url.href; });
    }
    // Without a card (unknown handle, failed request) the placeholder stays.
    felt.setAttribute('data-hh-kort', html ? '' : 'hr');
  }
  function hrHentKort() {
    hrKoeTimer = null;
    var felter = hrKoe;
    hrKoe = [];
    var mangler = [];
    felter.forEach(function (f) { if (!hrKortCache[f._hhHandle] && mangler.indexOf(f._hhHandle) < 0) mangler.push(f._hhHandle); });
    for (var i = 0; i < mangler.length; i += 20) {
      (function (del) {
        var job = fetch(hrKort.searchUrl + '?type=product&section_id=hh-search-cards&q=' + encodeURIComponent(del.join(' ')))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            var d = document.createElement('div');
            d.innerHTML = t;
            var kort = {};
            $$('[data-hh-sogkort]', d).forEach(function (k) { kort[k.getAttribute('data-hh-sogkort')] = k.innerHTML; });
            return kort;
          })
          .catch(function () { return {}; });
        del.forEach(function (h) { hrKortCache[h] = job.then(function (kort) { return kort[h] || ''; }); });
      })(mangler.slice(i, i + 20));
    }
    felter.forEach(function (f) { hrKortCache[f._hhHandle].then(function (html) { hrIndsaet(f, html); }); });
  }
  function hrNyeKort() {
    $$('.hh-sr-overlay .hr-search-overlay-product:not([data-hh-kort]):not([data-hh-venter])').forEach(function (f) {
      f.setAttribute('data-hh-venter', '');
      f._hhHandle = new URL(f.getAttribute('data-url') || '/', location.origin).pathname.split('/').pop();
      hrKoe.push(f);
    });
    if (hrKoe.length && !hrKoeTimer) hrKoeTimer = setTimeout(hrHentKort, 0);
  }
  // Mængdeberegner on pages (snippets/hh-volume-calc): the product calculator's sums without the
  // big bag answer.
  $$('[data-bgs]').forEach(function (bg) {
    var l = bg.querySelector('[data-bgs-l]'), b = bg.querySelector('[data-bgs-b]'), t = bg.querySelector('[data-bgs-t]');
    var tal = function (el) { var n = parseFloat((el.value || '').replace(',', '.')); return isNaN(n) || n < 0 ? 0 : n; };
    var dk = function (n, d) { return n.toFixed(d).replace('.', ','); };
    var tegn = function () {
      var areal = tal(l) * tal(b), m3 = areal * (tal(t) / 100);
      bg.querySelector('[data-bg-areal]').textContent = dk(areal, 2);
      bg.querySelector('[data-bg-m3]').textContent = dk(m3, 3);
      bg.querySelector('[data-bgs-liter]').textContent = Math.round(m3 * 1000).toLocaleString('da-DK');
    };
    var startDybde = t.value;
    bg.addEventListener('input', tegn);
    bg.querySelector('[data-bgs-nulstil]').addEventListener('click', function () {
      l.value = ''; b.value = ''; t.value = startDybde;
      tegn();
      l.focus();
    });
  });

  // Search fields carry data-hh-sog instead of name="q": Hello Retail's configs for the live theme
  // trigger on input[name='q'], this theme's own configs on the attribute. The query still goes to
  // /search as q, added when the form is sent (after Hello Retail has bound its triggers).
  document.addEventListener('submit', function (e) {
    var felt = e.target.querySelector && e.target.querySelector('input[data-hh-sog]');
    if (!felt) return;
    // With Hello Retail's overlay open the results are already on screen (it matches spelling
    // mistakes, Shopify's search does not), so the form stays; /search is the fallback without it.
    var sr = document.querySelector('.hh-sr-overlay');
    if (sr && getComputedStyle(sr).display !== 'none') {
      e.preventDefault();
      felt.blur();
      return;
    }
    var q = e.target.querySelector('input[type="hidden"][name="q"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'q';
      e.target.appendChild(q);
    }
    q.value = felt.value;
  }, true);

  // Mouse drag on the search overlay's category row, as on the carousels. The row is re-rendered
  // with every search, so the handlers are delegated; touch keeps native scrolling.
  (function () {
    var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var t = null, glid = 0, slipKlik = false;
    document.addEventListener('pointerdown', function (e) {
      var rk = e.pointerType === 'mouse' && e.button === 0 && e.target.closest && e.target.closest('.hh-sr__kat');
      if (!rk || rk.scrollWidth <= rk.clientWidth + 2) return;
      cancelAnimationFrame(glid);
      t = { rk: rk, x: e.clientX, venstre: rk.scrollLeft, sidst: e.clientX, tid: performance.now(), v: 0, flyttet: false };
    });
    addEventListener('pointermove', function (e) {
      if (!t) return;
      var dx = e.clientX - t.x;
      if (!t.flyttet && Math.abs(dx) < 5) return;
      if (!t.flyttet) { t.flyttet = true; t.rk.classList.add('is-traek'); }
      var nu = performance.now();
      t.v = (t.sidst - e.clientX) / Math.max(1, nu - t.tid);
      t.sidst = e.clientX; t.tid = nu;
      t.rk.scrollLeft = t.venstre - dx;
    });
    addEventListener('pointerup', function () {
      if (!t) return;
      var d = t; t = null;
      if (!d.flyttet) return;
      slipKlik = true;
      d.rk.classList.remove('is-traek');
      if (reduced) return;
      var v = d.v * 16;
      (function glide() {
        if (Math.abs(v) < 0.5) return;
        d.rk.scrollLeft += v;
        v *= 0.92;
        glid = requestAnimationFrame(glide);
      })();
    });
    document.addEventListener('dragstart', function (e) {
      if (e.target.closest && e.target.closest('.hh-sr__kat')) e.preventDefault();
    });
    // The grab cursor only where there is something to drag
    document.addEventListener('pointerover', function (e) {
      var rk = e.pointerType === 'mouse' && e.target.closest && e.target.closest('.hh-sr__kat');
      if (rk) rk.classList.toggle('kan-traek', rk.scrollWidth > rk.clientWidth + 2);
    });
    document.addEventListener('click', function (e) {
      if (!slipKlik) return;
      slipKlik = false;
      if (e.target.closest && e.target.closest('.hh-sr__kat')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  // Result tiles arrive with every render of the search overlay (config 52050)
  if (hrKort) new MutationObserver(hrNyeKort).observe(document.body, { childList: true, subtree: true });

  (function () {
    var hd = document.querySelector('[data-hd]');
    if (!hd) return;
    function maal() {
      document.documentElement.style.setProperty('--hd-h', hd.offsetHeight + 'px');
      bund();
    }
    // Where the header ends on screen (the announcement bar scrolls away above it). The Hello
    // Retail search overlay starts there instead of covering the header and the bar.
    function bund() {
      document.documentElement.style.setProperty('--hd-bund', Math.max(0, hd.getBoundingClientRect().bottom) + 'px');
    }
    maal();
    addEventListener('scroll', bund, { passive: true });
    document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('.search-field')) bund(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(maal);
    var t;
    addEventListener('resize', function () { clearTimeout(t); t = setTimeout(maal, 150); }, { passive: true });
  })();
})();
